


// // // import React, { useEffect, useState } from 'react';
// // // import { FaEdit, FaSave } from 'react-icons/fa';
// // // import axios from 'axios';
// // // import "./Settings.css";

// // // const Billing = () => {
// // //   const vendorId = localStorage.getItem("vendorId") || "42";

// // //   const [selectedOptions, setSelectedOptions] = useState({});
// // //   const [editMode, setEditMode] = useState({});
// // //   const [billingData, setBillingData] = useState(null);

// // //   // ✅ Initialize from API data
// // //   const initializeSelectedOptions = (apiData) => {
// // //     setSelectedOptions({
// // //       serviceCharges: {
// // //         discount: apiData.serviceCharges ?? 0,
// // //         type: apiData.serviceChargesType === "CUSTOMER_PAYABLE" ? "user" : "no user",
// // //         apply: apiData.serviceChargesApply || null,
// // //         unit: "Percentage",
// // //       },
// // //       platformCharges: {
// // //         type: apiData.platformChargeType === "CUSTOMER_PAYABLE" ? "user" : "no user",
// // //         unit: "Percentage",
// // //       }
// // //     });
// // //   };

// // //   // ✅ Fetch data from backend
// // //   const fetchBillingData = async () => {
// // //     const token = localStorage.getItem("authToken");
// // //     if (!token) {
// // //       console.warn("⚠️ No token found in localStorage.");
// // //       return null;
// // //     }

// // //     try {
// // //       const res = await axios.get(
// // //         `https://backend.maamaas.com/food/api/billing/get/${vendorId}`,
// // //         { headers: { Authorization: `Bearer ${token}` } }
// // //       );
// // //       setBillingData(res.data);
// // //       initializeSelectedOptions(res.data);
// // //       return res.data;
// // //     } catch (err) {
// // //       console.error("❌ Failed to fetch billing data:", err?.response?.data || err);
// // //       return null;
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     fetchBillingData();
// // //   }, []);

// // //   // ✅ Toggle Edit Mode
// // //   const toggleEdit = async (key) => {
// // //     const isEdit = editMode[key];
// // //     const token = localStorage.getItem("authToken");
// // //     const id = billingData?.id || null;

// // //     if (isEdit && id) {
// // //       const updatedData = {
// // //         ...billingData,
// // //         id,
// // //         vendorId,

// // //         serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
// // //         serviceChargesType:
// // //           selectedOptions.serviceCharges?.type === "user"
// // //             ? "CUSTOMER_PAYABLE"
// // //             : "BUSINESS_BORNE",
// // //         serviceChargesApply: selectedOptions.serviceCharges?.apply,

// // //         platformChargeType:
// // //           selectedOptions.platformCharges?.type === "user"
// // //             ? "CUSTOMER_PAYABLE"
// // //             : "BUSINESS_BORNE",
// // //       };

// // //       try {
// // //         await axios.put(
// // //           `https://backend.maamaas.com/food/api/billing/edit/${id}`,
// // //           updatedData,
// // //           {
// // //             headers: {
// // //               "Content-Type": "application/json",
// // //               ...(token && { Authorization: `Bearer ${token}` }),
// // //             },
// // //           }
// // //         );
// // //         alert("✅ Charges updated successfully!");
// // //         await fetchBillingData();
// // //       } catch (err) {
// // //         console.error("❌ Failed to update charges:", err);
// // //         alert("❌ Error saving changes.");
// // //       }
// // //     }

// // //     setEditMode((prev) => ({
// // //       ...prev,
// // //       [key]: !prev[key]
// // //     }));
// // //   };

// // //   // ✅ Toggle apply (Applicable / Not_Applicable)
// // //   const handleApplyChange = (label) => {
// // //     setSelectedOptions(prev => ({
// // //       ...prev,
// // //       [label]: {
// // //         ...prev[label],
// // //         apply: prev[label]?.apply === "Applicable" ? "Not_Applicable" : "Applicable",
// // //       },
// // //     }));
// // //   };

// // //   // ✅ Handle charge type checkbox (user / no user)
// // //   const handleOptionChange = (label, selectedType) => {
// // //     setSelectedOptions(prev => ({
// // //       ...prev,
// // //       [label]: {
// // //         ...prev[label],
// // //         type: selectedType
// // //       }
// // //     }));
// // //   };

// // //   // ✅ Handle numeric input for service charges only
// // //   const handleDiscountChange = (label, value) => {
// // //     setSelectedOptions(prev => ({
// // //       ...prev,
// // //       [label]: {
// // //         ...prev[label],
// // //         discount: value
// // //       }
// // //     }));
// // //   };

// // //   // ✅ Save all changes
// // //   const handleSaveCharges = async () => {
// // //     const token = localStorage.getItem("authToken");

// // //     const requestBody = {
// // //       ...billingData,
// // //       id: billingData?.id || 0,
// // //       vendorId: billingData?.vendorId || vendorId,

// // //       // Service charges (with numeric and apply)
// // //       serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
// // //       serviceChargesType:
// // //         selectedOptions.serviceCharges?.type === "user"
// // //           ? "CUSTOMER_PAYABLE"
// // //           : "BUSINESS_BORNE",
// // //       serviceChargesApply: selectedOptions.serviceCharges?.apply,

// // //       // Platform charges (type only)
// // //       platformChargeType:
// // //         selectedOptions.platformCharges?.type === "user"
// // //           ? "CUSTOMER_PAYABLE"
// // //           : "BUSINESS_BORNE",
// // //     };

// // //     try {
// // //       await axios.post(
// // //         `https://backend.maamaas.com/food/api/billing/add/charges/${vendorId}`,
// // //         requestBody,
// // //         {
// // //           headers: {
// // //             "Content-Type": "application/json",
// // //             ...(token && { Authorization: `Bearer ${token}` }),
// // //           },
// // //         }
// // //       );
// // //       alert("✅ Charges saved successfully!");
// // //     } catch (err) {
// // //       console.error("❌ Backend error:", err?.response?.data || err);
// // //       alert(`❌ Failed to save charges: ${err?.response?.data?.error || "Internal Server Error"}`);
// // //     }
// // //   };

// // //   return (
// // //     <div className='billingsetup' style={containerStyle}>
// // //       <div style={{
// // //         width: "100%",
// // //         overflowX: "auto",   // horizontal scroll
// // //         overflowY: "auto",   // vertical scroll
// // //         maxHeight: "500px",  // limit height

// // //       }}>
// // //         <table style={tableStyle}>
// // //           <thead>
// // //             <tr>
// // //               <th style={tableHeaderStyle}>Charge Type</th>
// // //               <th style={tableHeaderStyle}>Customer Payable</th>
// // //               <th style={tableHeaderStyle}>Business Borne</th>
// // //               <th style={tableHeaderStyle}>Visibility</th>
// // //               <th style={tableHeaderStyle}>Unit</th>
// // //               <th style={tableHeaderStyle}>Value</th>
// // //               <th style={tableHeaderStyle}>Actions</th>
// // //             </tr>
// // //           </thead>
// // //           <tbody>
// // //             {/* ✅ Service Charges Row */}
// // //             <tr>
// // //               <td style={tableCellStyle}><strong>Service Charges</strong></td>

// // //               <td style={tableCellStyle}>
// // //                 <input
// // //                   type="checkbox"
// // //                   checked={selectedOptions['serviceCharges']?.type === 'user'}
// // //                   onChange={() => handleOptionChange('serviceCharges', 'user')}
// // //                   disabled={!editMode['serviceCharges']}
// // //                   style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // //                 />
// // //               </td>

// // //               <td style={tableCellStyle}>
// // //                 <input
// // //                   type="checkbox"
// // //                   checked={selectedOptions['serviceCharges']?.type === 'no user'}
// // //                   onChange={() => handleOptionChange('serviceCharges', 'no user')}
// // //                   disabled={!editMode['serviceCharges']}
// // //                   style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // //                 />
// // //               </td>

// // //               <td style={tableCellStyle}>
// // //                 <input
// // //                   type="checkbox"
// // //                   checked={selectedOptions['serviceCharges']?.apply === 'Applicable'}
// // //                   onChange={() => handleApplyChange('serviceCharges')}
// // //                   disabled={!editMode['serviceCharges']}
// // //                   style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // //                 />
// // //               </td>

// // //               <td style={tableCellStyle}>Percentage</td>

// // //               <td style={tableCellStyle}>
// // //                 {editMode['serviceCharges'] ? (
// // //                   <input
// // //                     type="number"
// // //                     placeholder="Enter value"
// // //                     value={selectedOptions['serviceCharges']?.discount || ''}
// // //                     onChange={(e) => handleDiscountChange('serviceCharges', e.target.value)}
// // //                     style={inputStyle}
// // //                   />
// // //                 ) : (
// // //                   selectedOptions['serviceCharges']?.discount || '--'
// // //                 )}
// // //               </td>

// // //               <td style={tableCellStyle}>
// // //                 <button
// // //                   onClick={() => toggleEdit('serviceCharges')}
// // //                   style={iconButtonStyle}
// // //                 >
// // //                   {editMode['serviceCharges'] ? <FaSave /> : <FaEdit />}
// // //                 </button>
// // //               </td>
// // //             </tr>

// // //             {/* ✅ Platform Charges Row (Type only) */}
// // //             <tr>
// // //               <td style={tableCellStyle}><strong>Platform Charges</strong></td>

// // //               <td style={tableCellStyle}>
// // //                 <input
// // //                   type="checkbox"
// // //                   checked={selectedOptions['platformCharges']?.type === 'user'}
// // //                   onChange={() => handleOptionChange('platformCharges', 'user')}
// // //                   disabled={!editMode['platformCharges']}
// // //                   style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // //                 />
// // //               </td>

// // //               <td style={tableCellStyle}>
// // //                 <input
// // //                   type="checkbox"
// // //                   checked={selectedOptions['platformCharges']?.type === 'no user'}
// // //                   onChange={() => handleOptionChange('platformCharges', 'no user')}
// // //                   disabled={!editMode['platformCharges']}
// // //                   style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // //                 />
// // //               </td>

// // //               <td style={tableCellStyle}>--</td>
// // //               <td style={tableCellStyle}>--</td>
// // //               <td style={tableCellStyle}>--</td>

// // //               <td style={tableCellStyle}>
// // //                 <button
// // //                   onClick={() => toggleEdit('platformCharges')}
// // //                   style={iconButtonStyle}
// // //                 >
// // //                   {editMode['platformCharges'] ? <FaSave /> : <FaEdit />}
// // //                 </button>
// // //               </td>
// // //             </tr>
// // //           </tbody>
// // //         </table>
// // //       </div>
// // //       <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
// // //         <button
// // //           onClick={handleSaveCharges}
// // //           style={{
// // //             background: "rgb(177 93 198)",
// // //             color: "#fff",
// // //             borderRadius: "10px",
// // //             padding: "10px 20px",
// // //             border: "none",
// // //             cursor: "pointer"
// // //           }}
// // //         >
// // //           Save
// // //         </button>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // // Styles
// // // const containerStyle = {
// // //   maxWidth: '900px',
// // //   margin: '0 auto',
// // //   padding: '0px',
// // //   borderRadius: '12px',
// // //   fontFamily: 'Segoe UI, sans-serif',
// // // };

// // // const tableStyle = {
// // //   width: '100%',
// // //   borderCollapse: 'collapse',
// // //   marginTop:"20px",
// // // };

// // // const tableHeaderStyle = {
// // //   border: '1px solid #ddd',
// // //   textAlign: 'center',
// // //   fontWeight: 'bold',
// // //   backgroundColor: '#b15cd6',
// // //   color: 'white',
// // //   padding: '8px',
// // // };

// // // const tableCellStyle = {
// // //   border: '1px solid #ddd',
// // //   textAlign: 'center',
// // //   padding: '8px',
// // // };

// // // const inputStyle = {
// // //   width: '100px',
// // //   padding: '5px',
// // //   fontSize: '14px',
// // //   border: 'none',
// // //   outline: 'none',
// // //   backgroundColor: '#f7f7f7',
// // // };

// // // const iconButtonStyle = {
// // //   background: 'none',
// // //   border: 'none',
// // //   cursor: 'pointer',
// // //   fontSize: '18px',
// // //   color: '#4A148C',
// // // };

// // // export default Billing;







// // // // import React, { useEffect, useState } from 'react';
// // // // import { FaEdit, FaSave } from 'react-icons/fa';
// // // // import axios from 'axios';
// // // // import "./Settings.css";

// // // // const Billing = () => {
// // // //   const vendorId = localStorage.getItem("vendorId") || "42";

// // // //   const [selectedOptions, setSelectedOptions] = useState({});
// // // //   const [editMode, setEditMode] = useState({});
// // // //   const [billingData, setBillingData] = useState(null);
// // // //   const [showTooltip, setShowTooltip] = useState(false);

// // // //   // ✅ Simple state for send order functionality
// // // //   const [sendToOption, setSendToOption] = useState('none');
// // // //   // ✅ Function to map backend status to dropdown option
// // // //   const mapStatusToOption = (status) => {
// // // //     switch (status) {
// // // //       case 'CONFIRMED':
// // // //         return 'chef';
// // // //       case 'DELIVERED':
// // // //         return 'delivery';
// // // //       case 'PENDING':
// // // //       case 'HOLD':
// // // //       default:
// // // //         return 'none';
// // // //     }
// // // //   };

// // // //   // ✅ Function to map dropdown option to backend status
// // // //   const mapOptionToStatus = (option) => {
// // // //     switch (option) {
// // // //       case 'chef':
// // // //         return 'CONFIRMED';
// // // //       case 'delivery':
// // // //         return 'DELIVERED';
// // // //       case 'none':
// // // //       default:
// // // //         return 'PENDING';
// // // //     }
// // // //   };
// // // //   // ✅ Initialize from API data
// // // //   const initializeSelectedOptions = (apiData) => {
// // // //     setSelectedOptions({
// // // //       serviceCharges: {
// // // //         discount: apiData.serviceCharges ?? 0,
// // // //         type: apiData.serviceChargesType === "CUSTOMER_PAYABLE" ? "user" : "no user",
// // // //         apply: apiData.serviceChargesApply || null,
// // // //         unit: "Percentage",
// // // //       },
// // // //       platformCharges: {
// // // //         type: apiData.platformChargeType === "CUSTOMER_PAYABLE" ? "user" : "no user",
// // // //         unit: "Percentage",
// // // //       }
// // // //     });

// // // //     // ✅ Set the dropdown based on backend status
// // // //     if (apiData.initialOrderStatus) {
// // // //       const option = mapStatusToOption(apiData.initialOrderStatus);
// // // //       setSendToOption(option);
// // // //     }
// // // //   };

// // // //   // ✅ Fetch data from backend
// // // //   const fetchBillingData = async () => {
// // // //     const token = localStorage.getItem("authToken");
// // // //     if (!token) {
// // // //       console.warn("⚠️ No token found in localStorage.");
// // // //       return null;
// // // //     }

// // // //     try {
// // // //       const res = await axios.get(
// // // //         `https://backend.maamaas.com/food/api/billing/get/${vendorId}`,
// // // //         { headers: { Authorization: `Bearer ${token}` } }
// // // //       );
// // // //       setBillingData(res.data);
// // // //       initializeSelectedOptions(res.data);
// // // //       return res.data;
// // // //     } catch (err) {
// // // //       console.error("❌ Failed to fetch billing data:", err?.response?.data || err);
// // // //       return null;
// // // //     }
// // // //   };

// // // //   // ✅ Handle send order action
// // // //   const handleSendOrder = async () => {
// // // //     const token = localStorage.getItem("authToken");
// // // //     if (!token) {
// // // //       alert("No authentication token found");
// // // //       return;
// // // //     }


// // // //     let newStatus;
// // // //     switch (sendToOption) {
// // // //       case 'chef':
// // // //         newStatus = 'CONFIRMED';
// // // //         break;
// // // //       case 'delivery':
// // // //         newStatus = 'DELIVERED';
// // // //         break;
// // // //       case 'none':
// // // //       default:
// // // //         newStatus = 'PENDING';
// // // //         break;
// // // //     }

// // // //     try {
// // // //       // First get the current billing data
// // // //       const currentBillingData = billingData || await fetchBillingData();

// // // //       if (!currentBillingData) {
// // // //         alert("❌ No billing data found");
// // // //         return;
// // // //       }

// // // //       const updateData = {
// // // //         ...currentBillingData,
// // // //         initialOrderStatus: newStatus
// // // //       };

// // // //       // Use the PUT endpoint to update
// // // //       await axios.put(
// // // //         `https://backend.maamaas.com/food/api/billing/edit/${currentBillingData.id}`,
// // // //         updateData,
// // // //         {
// // // //           headers: {
// // // //             "Content-Type": "application/json",
// // // //             Authorization: `Bearer ${token}`,
// // // //           },
// // // //         }
// // // //       );

// // // //       alert(`✅ Order status updated to: ${newStatus}`);

// // // //       // Refresh billing data to show updated status
// // // //       fetchBillingData();

// // // //     } catch (error) {
// // // //       console.error("❌ Failed to update order status:", error);
// // // //       alert("❌ Error updating order status");
// // // //     }
// // // //   };

// // // //   useEffect(() => {
// // // //     fetchBillingData();
// // // //   }, []);

// // // //   // ✅ Toggle Edit Mode
// // // //   const toggleEdit = async (key) => {
// // // //     const isEdit = editMode[key];
// // // //     const token = localStorage.getItem("authToken");
// // // //     const id = billingData?.id || null;

// // // //     if (isEdit && id) {
// // // //       const updatedData = {
// // // //         ...billingData,
// // // //         id,
// // // //         vendorId,

// // // //         serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
// // // //         serviceChargesType:
// // // //           selectedOptions.serviceCharges?.type === "user"
// // // //             ? "CUSTOMER_PAYABLE"
// // // //             : "BUSINESS_BORNE",
// // // //         serviceChargesApply: selectedOptions.serviceCharges?.apply,

// // // //         platformChargeType:
// // // //           selectedOptions.platformCharges?.type === "user"
// // // //             ? "CUSTOMER_PAYABLE"
// // // //             : "BUSINESS_BORNE",
// // // //       };

// // // //       try {
// // // //         await axios.put(
// // // //           `https://backend.maamaas.com/food/api/billing/edit/${id}`,
// // // //           updatedData,
// // // //           {
// // // //             headers: {
// // // //               "Content-Type": "application/json",
// // // //               ...(token && { Authorization: `Bearer ${token}` }),
// // // //             },
// // // //           }
// // // //         );
// // // //         alert("✅ Charges updated successfully!");
// // // //         await fetchBillingData();
// // // //       } catch (err) {
// // // //         console.error("❌ Failed to update charges:", err);
// // // //         alert("❌ Error saving changes.");
// // // //       }
// // // //     }

// // // //     setEditMode((prev) => ({
// // // //       ...prev,
// // // //       [key]: !prev[key]
// // // //     }));
// // // //   };

// // // //   // ✅ Toggle apply (Applicable / Not_Applicable)
// // // //   const handleApplyChange = (label) => {
// // // //     setSelectedOptions(prev => ({
// // // //       ...prev,
// // // //       [label]: {
// // // //         ...prev[label],
// // // //         apply: prev[label]?.apply === "Applicable" ? "Not_Applicable" : "Applicable",
// // // //       },
// // // //     }));
// // // //   };

// // // //   // ✅ Handle charge type checkbox (user / no user)
// // // //   const handleOptionChange = (label, selectedType) => {
// // // //     setSelectedOptions(prev => ({
// // // //       ...prev,
// // // //       [label]: {
// // // //         ...prev[label],
// // // //         type: selectedType
// // // //       }
// // // //     }));
// // // //   };

// // // //   // ✅ Handle numeric input for service charges only
// // // //   const handleDiscountChange = (label, value) => {
// // // //     setSelectedOptions(prev => ({
// // // //       ...prev,
// // // //       [label]: {
// // // //         ...prev[label],
// // // //         discount: value
// // // //       }
// // // //     }));
// // // //   };

// // // //   // ✅ Save all changes
// // // //   const handleSaveCharges = async () => {
// // // //     const token = localStorage.getItem("authToken");

// // // //     const requestBody = {
// // // //       ...billingData,
// // // //       id: billingData?.id || 0,
// // // //       vendorId: billingData?.vendorId || vendorId,

// // // //       // Service charges (with numeric and apply)
// // // //       serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
// // // //       serviceChargesType:
// // // //         selectedOptions.serviceCharges?.type === "user"
// // // //           ? "CUSTOMER_PAYABLE"
// // // //           : "BUSINESS_BORNE",
// // // //       serviceChargesApply: selectedOptions.serviceCharges?.apply,

// // // //       // Platform charges (type only)
// // // //       platformChargeType:
// // // //         selectedOptions.platformCharges?.type === "user"
// // // //           ? "CUSTOMER_PAYABLE"
// // // //           : "BUSINESS_BORNE",
// // // //     };

// // // //     try {
// // // //       await axios.post(
// // // //         `https://backend.maamaas.com/food/api/billing/add/charges/${vendorId}`,
// // // //         requestBody,
// // // //         {
// // // //           headers: {
// // // //             "Content-Type": "application/json",
// // // //             ...(token && { Authorization: `Bearer ${token}` }),
// // // //           },
// // // //         }
// // // //       );
// // // //       alert("✅ Charges saved successfully!");
// // // //     } catch (err) {
// // // //       console.error("❌ Backend error:", err?.response?.data || err);
// // // //       alert(`❌ Failed to save charges: ${err?.response?.data?.error || "Internal Server Error"}`);
// // // //     }
// // // //   };

// // // //   return (
// // // //     <div className='billingsetup' style={containerStyle}>


// // // //       {/* Billing Table Section */}
// // // //       <div style={{ marginBottom: '20px' }}>
// // // //         <h3 style={{ marginBottom: '0px', color: 'rgb(177, 92, 214)' }}>Billing Configuration</h3>
// // // //         <div style={{
// // // //           width: "100%",
// // // //           overflowX: "auto",
// // // //           overflowY: "auto",
// // // //           maxHeight: "500px",
// // // //         }}>
// // // //           <table style={tableStyle}>
// // // //             <thead>
// // // //               <tr>
// // // //                 <th style={tableHeaderStyle}>Charge Type</th>
// // // //                 <th style={tableHeaderStyle}>Customer Payable</th>
// // // //                 <th style={tableHeaderStyle}>Business Borne</th>
// // // //                 <th style={tableHeaderStyle}>Visibility</th>
// // // //                 <th style={tableHeaderStyle}>Unit</th>
// // // //                 <th style={tableHeaderStyle}>Value</th>
// // // //                 <th style={tableHeaderStyle}>Actions</th>
// // // //               </tr>
// // // //             </thead>
// // // //             <tbody>
// // // //               {/* ✅ Service Charges Row */}
// // // //               <tr>
// // // //                 <td style={tableCellStyle}><strong>Service Charges</strong></td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <input
// // // //                     type="checkbox"
// // // //                     checked={selectedOptions['serviceCharges']?.type === 'user'}
// // // //                     onChange={() => handleOptionChange('serviceCharges', 'user')}
// // // //                     disabled={!editMode['serviceCharges']}
// // // //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // // //                   />
// // // //                 </td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <input
// // // //                     type="checkbox"
// // // //                     checked={selectedOptions['serviceCharges']?.type === 'no user'}
// // // //                     onChange={() => handleOptionChange('serviceCharges', 'no user')}
// // // //                     disabled={!editMode['serviceCharges']}
// // // //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // // //                   />
// // // //                 </td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <input
// // // //                     type="checkbox"
// // // //                     checked={selectedOptions['serviceCharges']?.apply === 'Applicable'}
// // // //                     onChange={() => handleApplyChange('serviceCharges')}
// // // //                     disabled={!editMode['serviceCharges']}
// // // //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // // //                   />
// // // //                 </td>
// // // //                 <td style={tableCellStyle}>Percentage</td>
// // // //                 <td style={tableCellStyle}>
// // // //                   {editMode['serviceCharges'] ? (
// // // //                     <input
// // // //                       type="number"
// // // //                       placeholder="Enter value"
// // // //                       value={selectedOptions['serviceCharges']?.discount || ''}
// // // //                       onChange={(e) => handleDiscountChange('serviceCharges', e.target.value)}
// // // //                       style={inputStyle}
// // // //                     />
// // // //                   ) : (
// // // //                     selectedOptions['serviceCharges']?.discount || '--'
// // // //                   )}
// // // //                 </td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <button
// // // //                     onClick={() => toggleEdit('serviceCharges')}
// // // //                     style={iconButtonStyle}
// // // //                   >
// // // //                     {editMode['serviceCharges'] ? <FaSave /> : <FaEdit />}
// // // //                   </button>
// // // //                 </td>
// // // //               </tr>

// // // //               {/* ✅ Platform Charges Row (Type only) */}
// // // //               <tr>
// // // //                 <td style={tableCellStyle}><strong>Platform Charges</strong></td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <input
// // // //                     type="checkbox"
// // // //                     checked={selectedOptions['platformCharges']?.type === 'user'}
// // // //                     onChange={() => handleOptionChange('platformCharges', 'user')}
// // // //                     disabled={!editMode['platformCharges']}
// // // //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // // //                   />
// // // //                 </td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <input
// // // //                     type="checkbox"
// // // //                     checked={selectedOptions['platformCharges']?.type === 'no user'}
// // // //                     onChange={() => handleOptionChange('platformCharges', 'no user')}
// // // //                     disabled={!editMode['platformCharges']}
// // // //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // // //                   />
// // // //                 </td>
// // // //                 <td style={tableCellStyle}>--</td>
// // // //                 <td style={tableCellStyle}>--</td>
// // // //                 <td style={tableCellStyle}>--</td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <button
// // // //                     onClick={() => toggleEdit('platformCharges')}
// // // //                     style={iconButtonStyle}
// // // //                   >
// // // //                     {editMode['platformCharges'] ? <FaSave /> : <FaEdit />}
// // // //                   </button>
// // // //                 </td>
// // // //               </tr>
// // // //             </tbody>
// // // //           </table>
// // // //         </div>
// // // //       </div>

// // // //       <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
// // // //         <button
// // // //           onClick={handleSaveCharges}
// // // //           style={{
// // // //             background: "rgb(177 93 198)",
// // // //             color: "#fff",
// // // //             borderRadius: "6px",
// // // //             padding: "8px 20px",
// // // //             border: "none",
// // // //             cursor: "pointer"
// // // //           }}
// // // //         >
// // // //           Save
// // // //         </button>
// // // //       </div>

// // // //       {/* Simple One-Line Send Order Table */}
// // // //       <div style={{ marginBottom: '30px' }}>
// // // //         <h3 style={{ marginBottom: '15px', color: 'rgb(177, 92, 214)' }}>Order Status Control</h3>
// // // //         <div style={{
// // // //           width: "100%",
// // // //           overflowX: "auto",
// // // //           border: '1px solid #ddd',
// // // //           borderRadius: '8px',
// // // //           backgroundColor: '#f8f9fa'
// // // //         }}>
// // // //           <table style={simpleTableStyle}>
// // // //             <tbody>
// // // //               <tr>
// // // //                 <td style={{...simpleCellStyle , whiteSpace:"nowrap"}}>
// // // //                   <strong>Send Order To :</strong>
// // // //                   {/* {billingData?.initialOrderStatus && (
// // // //                     <div style={{
// // // //                       fontSize: '12px',
// // // //                       color: '#666',
// // // //                       marginTop: '4px',
// // // //                       fontWeight: 'normal'
// // // //                     }}>
// // // //                       Current: {billingData.initialOrderStatus}
// // // //                     </div>
// // // //                   )} */}
// // // //                 </td>
// // // //                 <td style={simpleCellStyle}>
// // // //                   <select
// // // //                     value={sendToOption}
// // // //                     onChange={(e) => setSendToOption(e.target.value)}
// // // //                     style={{
// // // //                       padding: '8px 12px',
// // // //                       borderRadius: '6px',
// // // //                       border: '1px solid #ccc',
// // // //                       backgroundColor: 'white',
// // // //                       minWidth: window.innerWidth<500 ? "auto" :'200px',
// // // //                       fontSize: '14px',
// // // //                       textAlign: 'center',
// // // //                     }}
// // // //                   >
// // // //                     <option value="none">None</option>
// // // //                     <option value="chef">Chef</option>
// // // //                     <option value="delivery">Delivery</option>
// // // //                   </select>
// // // //                 </td>
// // // //                 <td style={{...simpleCellStyle ,textAlign: 'right',}}>
// // // //                   <button
// // // //                     onClick={handleSendOrder}
// // // //                     style={{
// // // //                       background: "rgb(177, 92, 214)",
// // // //                       color: "white",
// // // //                       border: "none",
// // // //                       borderRadius: "6px",
// // // //                       padding:window.innerWidth<500 ? "8px 15px": "8px 24px",
// // // //                       cursor: "pointer",
// // // //                       // fontWeight: "bold",
// // // //                       fontSize: '14px'
// // // //                     }}
// // // //                   >
// // // //                     Confirm
// // // //                   </button>
// // // //                 </td>
// // // //               </tr>
// // // //             </tbody>
// // // //           </table>
// // // //         </div>

// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // // Styles
// // // // const containerStyle = {
// // // //   maxWidth: '900px',
// // // //   margin: '0 auto',
// // // //   padding: '20px',
// // // //   borderRadius: '12px',
// // // //   fontFamily: 'Segoe UI, sans-serif',
// // // // };

// // // // const tableStyle = {
// // // //   width: '100%',
// // // //   borderCollapse: 'collapse',
// // // //   marginTop: "20px",
// // // // };

// // // // const tableHeaderStyle = {
// // // //   border: '1px solid #ddd',
// // // //   textAlign: 'center',
// // // //   fontWeight: 'bold',
// // // //   backgroundColor: '#b15cd6',
// // // //   color: 'white',
// // // //   padding: '8px',
// // // // };

// // // // const tableCellStyle = {
// // // //   border: '1px solid #ddd',
// // // //   textAlign: 'center',
// // // //   padding: '8px',
// // // // };

// // // // // Simple table styles for send order section
// // // // const simpleTableStyle = {
// // // //   width: '100%',
// // // //   borderCollapse: 'collapse',
// // // // };

// // // // const simpleCellStyle = {
// // // //   padding:window.innerWidth<500 ? "5px": '15px',
// // // //   textAlign: 'left',
// // // //   borderBottom: '1px solid #eee',
// // // // };

// // // // const inputStyle = {
// // // //   width: '100px',
// // // //   padding: '5px',
// // // //   fontSize: '14px',
// // // //   border: 'none',
// // // //   outline: 'none',
// // // //   backgroundColor: '#f7f7f7',
// // // // };

// // // // const iconButtonStyle = {
// // // //   background: 'none',
// // // //   border: 'none',
// // // //   cursor: 'pointer',
// // // //   fontSize: '18px',
// // // //   color: '#4A148C',
// // // // };

// // // // export default Billing;








// // // // import React, { useEffect, useState } from 'react';
// // // // import { FaEdit, FaSave } from 'react-icons/fa';
// // // // import axios from 'axios';
// // // // import "./Settings.css";

// // // // const Billing = () => {
// // // //   const vendorId = localStorage.getItem("vendorId") || "42";

// // // //   const [selectedOptions, setSelectedOptions] = useState({});
// // // //   const [editMode, setEditMode] = useState({});
// // // //   const [billingData, setBillingData] = useState(null);
// // // //   const [showTooltip, setShowTooltip] = useState(false);
// // // //   const [isEditMode, setIsEditMode] = useState(false);

// // // //   // ✅ Simple state for send order functionality
// // // //   const [sendToOption, setSendToOption] = useState('none');
// // // //   // ✅ Function to map backend status to dropdown option
// // // //   // ✅ Function to map backend status to dropdown option
// // // //   const mapStatusToOption = (status) => {
// // // //     switch (status) {
// // // //       case 'CONFIRMED':
// // // //         return 'chef';
// // // //       case 'DELIVERED':
// // // //         return 'delivery';
// // // //       case 'HOLD':
// // // //       default:
// // // //         return 'delivery';
// // // //     }
// // // //   };

// // // //   // ✅ Function to map dropdown option to backend status
// // // //   const mapOptionToStatus = (option) => {
// // // //     switch (option) {
// // // //       case 'chef':
// // // //         return 'CONFIRMED';
// // // //       case 'delivery':
// // // //       default:
// // // //         return 'DELIVERED';
// // // //     }
// // // //   };
// // // //   // ✅ Initialize from API data
// // // //   const initializeSelectedOptions = (apiData) => {
// // // //     setSelectedOptions({
// // // //       serviceCharges: {
// // // //         discount: apiData.serviceCharges ?? 0,
// // // //         type: apiData.serviceChargesType === "CUSTOMER_PAYABLE" ? "user" : "no user",
// // // //         apply: apiData.serviceChargesApply || null,
// // // //         unit: "Percentage",
// // // //       },
// // // //       platformCharges: {
// // // //         type: apiData.platformChargeType === "CUSTOMER_PAYABLE" ? "user" : "no user",
// // // //         unit: "Percentage",
// // // //       }
// // // //     });

// // // //     // ✅ Set the dropdown based on backend status
// // // //     if (apiData.initialOrderStatus) {
// // // //       const option = mapStatusToOption(apiData.initialOrderStatus);
// // // //       setSendToOption(option);
// // // //     }
// // // //   };

// // // //   // ✅ Fetch data from backend
// // // //   const fetchBillingData = async () => {
// // // //     const token = localStorage.getItem("authToken");
// // // //     if (!token) {
// // // //       console.warn("⚠️ No token found in localStorage.");
// // // //       return null;
// // // //     }

// // // //     try {
// // // //       const res = await axios.get(
// // // //         `https://backend.maamaas.com/food/api/billing/get/${vendorId}`,
// // // //         { headers: { Authorization: `Bearer ${token}` } }
// // // //       );
// // // //       setBillingData(res.data);
// // // //       initializeSelectedOptions(res.data);
// // // //       return res.data;
// // // //     } catch (err) {
// // // //       console.error("❌ Failed to fetch billing data:", err?.response?.data || err);
// // // //       return null;
// // // //     }
// // // //   };

// // // //   // ✅ Handle send order action
// // // //   const handleSendOrder = async () => {
// // // //     const token = localStorage.getItem("authToken");
// // // //     if (!token) {
// // // //       alert("No authentication token found");
// // // //       return;
// // // //     }


// // // //     let newStatus;
// // // //     switch (sendToOption) {
// // // //       case 'chef':
// // // //         newStatus = 'CONFIRMED';
// // // //         break;
// // // //       case 'delivery':
// // // //         newStatus = 'DELIVERED';
// // // //         break;
// // // //       case 'none':
// // // //       default:
// // // //         newStatus = 'PENDING';
// // // //         break;
// // // //     }

// // // //     try {
// // // //       // First get the current billing data
// // // //       const currentBillingData = billingData || await fetchBillingData();

// // // //       if (!currentBillingData) {
// // // //         alert("❌ No billing data found");
// // // //         return;
// // // //       }

// // // //       const updateData = {
// // // //         ...currentBillingData,
// // // //         initialOrderStatus: newStatus
// // // //       };

// // // //       // Use the PUT endpoint to update
// // // //       await axios.put(
// // // //         `https://backend.maamaas.com/food/api/billing/edit/${currentBillingData.id}`,
// // // //         updateData,
// // // //         {
// // // //           headers: {
// // // //             "Content-Type": "application/json",
// // // //             Authorization: `Bearer ${token}`,
// // // //           },
// // // //         }
// // // //       );

// // // //       alert(`✅ Order status updated to: ${newStatus}`);

// // // //       // Refresh billing data to show updated status
// // // //       fetchBillingData();

// // // //     } catch (error) {
// // // //       console.error("❌ Failed to update order status:", error);
// // // //       alert("❌ Error updating order status");
// // // //     }
// // // //   };

// // // //   useEffect(() => {
// // // //     fetchBillingData();
// // // //   }, []);

// // // //   // ✅ Toggle Edit Mode
// // // //   const toggleEdit = async (key) => {
// // // //     const isEdit = editMode[key];
// // // //     const token = localStorage.getItem("authToken");
// // // //     const id = billingData?.id || null;

// // // //     if (isEdit && id) {
// // // //       const updatedData = {
// // // //         ...billingData,
// // // //         id,
// // // //         vendorId,

// // // //         serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
// // // //         serviceChargesType:
// // // //           selectedOptions.serviceCharges?.type === "user"
// // // //             ? "CUSTOMER_PAYABLE"
// // // //             : "BUSINESS_BORNE",
// // // //         serviceChargesApply: selectedOptions.serviceCharges?.apply,

// // // //         platformChargeType:
// // // //           selectedOptions.platformCharges?.type === "user"
// // // //             ? "CUSTOMER_PAYABLE"
// // // //             : "BUSINESS_BORNE",
// // // //       };

// // // //       try {
// // // //         await axios.put(
// // // //           `https://backend.maamaas.com/food/api/billing/edit/${id}`,
// // // //           updatedData,
// // // //           {
// // // //             headers: {
// // // //               "Content-Type": "application/json",
// // // //               ...(token && { Authorization: `Bearer ${token}` }),
// // // //             },
// // // //           }
// // // //         );
// // // //         alert("✅ Charges updated successfully!");
// // // //         await fetchBillingData();
// // // //       } catch (err) {
// // // //         console.error("❌ Failed to update charges:", err);
// // // //         alert("❌ Error saving changes.");
// // // //       }
// // // //     }

// // // //     setEditMode((prev) => ({
// // // //       ...prev,
// // // //       [key]: !prev[key]
// // // //     }));
// // // //   };

// // // //   // ✅ Toggle apply (Applicable / Not_Applicable)
// // // //   const handleApplyChange = (label) => {
// // // //     setSelectedOptions(prev => ({
// // // //       ...prev,
// // // //       [label]: {
// // // //         ...prev[label],
// // // //         apply: prev[label]?.apply === "Applicable" ? "Not_Applicable" : "Applicable",
// // // //       },
// // // //     }));
// // // //   };

// // // //   // ✅ Handle charge type checkbox (user / no user)
// // // //   const handleOptionChange = (label, selectedType) => {
// // // //     setSelectedOptions(prev => ({
// // // //       ...prev,
// // // //       [label]: {
// // // //         ...prev[label],
// // // //         type: selectedType
// // // //       }
// // // //     }));
// // // //   };

// // // //   // ✅ Handle numeric input for service charges only
// // // //   const handleDiscountChange = (label, value) => {
// // // //     setSelectedOptions(prev => ({
// // // //       ...prev,
// // // //       [label]: {
// // // //         ...prev[label],
// // // //         discount: value
// // // //       }
// // // //     }));
// // // //   };

// // // //   // ✅ Save all changes
// // // //   const handleSaveCharges = async () => {
// // // //     const token = localStorage.getItem("authToken");

// // // //     const requestBody = {
// // // //       ...billingData,
// // // //       id: billingData?.id || 0,
// // // //       vendorId: billingData?.vendorId || vendorId,

// // // //       // Service charges (with numeric and apply)
// // // //       serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
// // // //       serviceChargesType:
// // // //         selectedOptions.serviceCharges?.type === "user"
// // // //           ? "CUSTOMER_PAYABLE"
// // // //           : "BUSINESS_BORNE",
// // // //       serviceChargesApply: selectedOptions.serviceCharges?.apply,

// // // //       // Platform charges (type only)
// // // //       platformChargeType:
// // // //         selectedOptions.platformCharges?.type === "user"
// // // //           ? "CUSTOMER_PAYABLE"
// // // //           : "BUSINESS_BORNE",
// // // //     };

// // // //     try {
// // // //       await axios.post(
// // // //         `https://backend.maamaas.com/food/api/billing/add/charges/${vendorId}`,
// // // //         requestBody,
// // // //         {
// // // //           headers: {
// // // //             "Content-Type": "application/json",
// // // //             ...(token && { Authorization: `Bearer ${token}` }),
// // // //           },
// // // //         }
// // // //       );
// // // //       alert("✅ Charges saved successfully!");
// // // //     } catch (err) {
// // // //       console.error("❌ Backend error:", err?.response?.data || err);
// // // //       alert(`❌ Failed to save charges: ${err?.response?.data?.error || "Internal Server Error"}`);
// // // //     }
// // // //   };
// // // //   // Handle edit button click
// // // //   const handleEditClick = () => {
// // // //     setIsEditMode(true);
// // // //   };

// // // //   // Handle save/confirm button click
// // // //   const handleSaveClick = async () => {
// // // //     const token = localStorage.getItem("authToken");
// // // //     if (!token) {
// // // //       alert("No authentication token found");
// // // //       return;
// // // //     }

// // // //     let newStatus;
// // // //     switch (sendToOption) {
// // // //       case 'chef':
// // // //         newStatus = 'CONFIRMED';
// // // //         break;
// // // //       case 'delivery':
// // // //       default:
// // // //         newStatus = 'DELIVERED';
// // // //         break;
// // // //     }

// // // //     try {
// // // //       const currentBillingData = billingData || await fetchBillingData();
// // // //       if (!currentBillingData) {
// // // //         alert("❌ No billing data found");
// // // //         return;
// // // //       }

// // // //       const updateData = {
// // // //         ...currentBillingData,
// // // //         initialOrderStatus: newStatus
// // // //       };

// // // //       await axios.put(
// // // //         `https://backend.maamaas.com/food/api/billing/edit/${currentBillingData.id}`,
// // // //         updateData,
// // // //         {
// // // //           headers: {
// // // //             "Content-Type": "application/json",
// // // //             Authorization: `Bearer ${token}`,
// // // //           },
// // // //         }
// // // //       );

// // // //       alert(`✅ Order status updated to: ${newStatus}`);
// // // //       setIsEditMode(false);
// // // //       fetchBillingData();

// // // //     } catch (error) {
// // // //       console.error("❌ Failed to update order status:", error);
// // // //       alert("❌ Error updating order status");
// // // //     }
// // // //   };

// // // //   // Handle cancel edit
// // // //   const handleCancelEdit = () => {
// // // //     if (billingData?.initialOrderStatus) {
// // // //       const option = mapStatusToOption(billingData.initialOrderStatus);
// // // //       setSendToOption(option);
// // // //     }
// // // //     setIsEditMode(false);
// // // //   };
// // // //   return (
// // // //     <div className='billingsetup' style={containerStyle}>


// // // //       {/* Billing Table Section */}
// // // //       <div style={{ marginBottom: '20px' }}>
// // // //         <h3 style={{ marginBottom: '0px', color: 'rgb(177, 92, 214)' }}>Billing Configuration</h3>
// // // //         <div style={{
// // // //           width: "100%",
// // // //           overflowX: "auto",
// // // //           overflowY: "auto",
// // // //           maxHeight: "500px",
// // // //         }}>
// // // //           <table style={tableStyle}>
// // // //             <thead>
// // // //               <tr>
// // // //                 <th style={tableHeaderStyle}>Charge Type</th>
// // // //                 <th style={tableHeaderStyle}>Customer Payable</th>
// // // //                 <th style={tableHeaderStyle}>Business Borne</th>
// // // //                 <th style={tableHeaderStyle}>Visibility</th>
// // // //                 <th style={tableHeaderStyle}>Unit</th>
// // // //                 <th style={tableHeaderStyle}>Value</th>
// // // //                 <th style={tableHeaderStyle}>Actions</th>
// // // //               </tr>
// // // //             </thead>
// // // //             <tbody>
// // // //               {/* ✅ Service Charges Row */}
// // // //               <tr>
// // // //                 <td style={tableCellStyle}><strong>Service Charges</strong></td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <input
// // // //                     type="checkbox"
// // // //                     checked={selectedOptions['serviceCharges']?.type === 'user'}
// // // //                     onChange={() => handleOptionChange('serviceCharges', 'user')}
// // // //                     disabled={!editMode['serviceCharges']}
// // // //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // // //                   />
// // // //                 </td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <input
// // // //                     type="checkbox"
// // // //                     checked={selectedOptions['serviceCharges']?.type === 'no user'}
// // // //                     onChange={() => handleOptionChange('serviceCharges', 'no user')}
// // // //                     disabled={!editMode['serviceCharges']}
// // // //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // // //                   />
// // // //                 </td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <input
// // // //                     type="checkbox"
// // // //                     checked={selectedOptions['serviceCharges']?.apply === 'Applicable'}
// // // //                     onChange={() => handleApplyChange('serviceCharges')}
// // // //                     disabled={!editMode['serviceCharges']}
// // // //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // // //                   />
// // // //                 </td>
// // // //                 <td style={tableCellStyle}>Percentage</td>
// // // //                 <td style={tableCellStyle}>
// // // //                   {editMode['serviceCharges'] ? (
// // // //                     <input
// // // //                       type="number"
// // // //                       placeholder="Enter value"
// // // //                       value={selectedOptions['serviceCharges']?.discount || ''}
// // // //                       onChange={(e) => handleDiscountChange('serviceCharges', e.target.value)}
// // // //                       style={inputStyle}
// // // //                     />
// // // //                   ) : (
// // // //                     selectedOptions['serviceCharges']?.discount || '--'
// // // //                   )}
// // // //                 </td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <button
// // // //                     onClick={() => toggleEdit('serviceCharges')}
// // // //                     style={iconButtonStyle}
// // // //                   >
// // // //                     {editMode['serviceCharges'] ? <FaSave /> : <FaEdit />}
// // // //                   </button>
// // // //                 </td>
// // // //               </tr>

// // // //               {/* ✅ Platform Charges Row (Type only) */}
// // // //               <tr>
// // // //                 <td style={tableCellStyle}><strong>Platform Charges</strong></td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <input
// // // //                     type="checkbox"
// // // //                     checked={selectedOptions['platformCharges']?.type === 'user'}
// // // //                     onChange={() => handleOptionChange('platformCharges', 'user')}
// // // //                     disabled={!editMode['platformCharges']}
// // // //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // // //                   />
// // // //                 </td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <input
// // // //                     type="checkbox"
// // // //                     checked={selectedOptions['platformCharges']?.type === 'no user'}
// // // //                     onChange={() => handleOptionChange('platformCharges', 'no user')}
// // // //                     disabled={!editMode['platformCharges']}
// // // //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// // // //                   />
// // // //                 </td>
// // // //                 <td style={tableCellStyle}>--</td>
// // // //                 <td style={tableCellStyle}>--</td>
// // // //                 <td style={tableCellStyle}>--</td>
// // // //                 <td style={tableCellStyle}>
// // // //                   <button
// // // //                     onClick={() => toggleEdit('platformCharges')}
// // // //                     style={iconButtonStyle}
// // // //                   >
// // // //                     {editMode['platformCharges'] ? <FaSave /> : <FaEdit />}
// // // //                   </button>
// // // //                 </td>
// // // //               </tr>
// // // //             </tbody>
// // // //           </table>
// // // //         </div>
// // // //       </div>

// // // //       <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
// // // //         <button
// // // //           onClick={handleSaveCharges}
// // // //           style={{
// // // //             background: "rgb(177 93 198)",
// // // //             color: "#fff",
// // // //             borderRadius: "6px",
// // // //             padding: "8px 20px",
// // // //             border: "none",
// // // //             cursor: "pointer"
// // // //           }}
// // // //         >
// // // //           Save
// // // //         </button>
// // // //       </div>

// // // //       {/* Simple One-Line Send Order Table */}
// // // //       <div style={{ marginBottom: '30px' }}>
// // // //         <div style={{ position: 'relative', display: 'inline-block' }}>
// // // //           <div style={{ position: 'relative', display: 'inline-block' }}>
// // // //             <h3 style={{ marginBottom: '15px', color: 'rgb(177, 92, 214)', display: 'flex', alignItems: 'center', gap: '8px' }}>
// // // //               Order Destination
// // // //               <span
// // // //                 style={{
// // // //                   cursor: 'pointer',
// // // //                   fontSize: '16px',
// // // //                   color: 'rgb(177, 92, 214)',
// // // //                   display: 'inline-flex',
// // // //                   alignItems: 'center',
// // // //                   justifyContent: 'center',
// // // //                   background: 'rgba(177, 92, 214, 0.1)',
// // // //                   borderRadius: '50%',
// // // //                   marginTop:"8px",
// // // //                   width: '20px',
// // // //                   height: '20px',
// // // //                   fontWeight: 'bold',
// // // //                   border: '1px solid rgba(177, 92, 214, 0.3)',
// // // //                 }}
// // // //                 onMouseEnter={() => setShowTooltip(true)}
// // // //                 onMouseLeave={() => setShowTooltip(false)}
// // // //               >
// // // //                 i
// // // //               </span>
// // // //             </h3>

// // // //             {showTooltip && (
// // // //               <div style={{
// // // //                 position: 'absolute',
// // // //                 top: '40px',
// // // //                 left: '0',
// // // //                 backgroundColor: '#333',
// // // //                 color: 'white',
// // // //                 padding: '10px',
// // // //                 borderRadius: '4px',
// // // //                 fontSize: '12px',
// // // //                 width: '250px',
// // // //                 zIndex: 1000,
// // // //                 boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
// // // //               }}>
// // // //                 <strong>Choose where orders go after placement:</strong><br /><br />
// // // //                 • <strong>Delivery:</strong> Orders are marked as completed for delivery.<br />
// // // //                 • <strong>Chef:</strong> Orders go to kitchen for preparation first.
// // // //               </div>
// // // //             )}
// // // //           </div>
// // // //         </div>
// // // //         <div style={{
// // // //           width: "100%",
// // // //           overflowX: "auto",
// // // //           border: '1px solid #ddd',
// // // //           borderRadius: '8px',
// // // //           backgroundColor: '#f8f9fa'
// // // //         }}>
// // // //           <table style={simpleTableStyle}>
// // // //             <tbody>
// // // //               <tr>
// // // //                 <td style={{ ...simpleCellStyle, whiteSpace: "nowrap" }}>
// // // //                   <strong>Send Order To :</strong>
// // // //                   {/* {billingData?.initialOrderStatus && (
// // // //                     <div style={{
// // // //                       fontSize: '12px',
// // // //                       color: '#666',
// // // //                       marginTop: '4px',
// // // //                       fontWeight: 'normal'
// // // //                     }}>
// // // //                       Current: {billingData.initialOrderStatus}
// // // //                     </div>
// // // //                   )} */}
// // // //                 </td>
// // // //                 <td style={simpleCellStyle}>
// // // //                   <select
// // // //                     value={sendToOption}
// // // //                     onChange={(e) => setSendToOption(e.target.value)}
// // // //                     disabled={!isEditMode}
// // // //                     style={{
// // // //                       padding: '8px 12px',
// // // //                       borderRadius: '6px',
// // // //                       border: '1px solid #ccc',
// // // //                       backgroundColor: 'white',
// // // //                       minWidth: window.innerWidth < 500 ? "auto" : '200px',
// // // //                       fontSize: '14px',
// // // //                       textAlign: 'center',
// // // //                     }}
// // // //                   >

// // // //                     <option value="chef">Chef</option>
// // // //                     <option value="delivery">Delivery</option>
// // // //                   </select>
// // // //                 </td>
// // // //                 <td style={{ ...simpleCellStyle, textAlign: 'right', }}>
// // // //                   {!isEditMode ? (
// // // //                     <button
// // // //                       onClick={handleEditClick}
// // // //                       style={{
// // // //                         background: "#4A148C",
// // // //                         color: "white",
// // // //                         border: "none",
// // // //                         borderRadius: "6px",
// // // //                         padding: window.innerWidth < 500 ? "8px 15px" : "8px 24px",
// // // //                         cursor: "pointer",
// // // //                         fontSize: '14px'
// // // //                       }}
// // // //                     >
// // // //                       Edit
// // // //                     </button>
// // // //                   ) : (
// // // //                     <>
// // // //                       {/* <button
// // // //                         onClick={handleCancelEdit}
// // // //                         style={{
// // // //                           background: "#6c757d",
// // // //                           color: "white",
// // // //                           border: "none",
// // // //                           borderRadius: "6px",
// // // //                           padding: window.innerWidth < 500 ? "8px 15px" : "8px 24px",
// // // //                           cursor: "pointer",
// // // //                           fontSize: '14px'
// // // //                         }}
// // // //                       >
// // // //                         Cancel
// // // //                       </button> */}
// // // //                       <button
// // // //                         onClick={handleSaveClick}
// // // //                         style={{
// // // //                           background: "rgb(177, 92, 214)",
// // // //                           color: "white",
// // // //                           border: "none",
// // // //                           borderRadius: "6px",
// // // //                           padding: window.innerWidth < 500 ? "8px 15px" : "8px 24px",
// // // //                           cursor: "pointer",
// // // //                           fontSize: '14px'
// // // //                         }}
// // // //                       >
// // // //                         Save
// // // //                       </button>
// // // //                     </>
// // // //                   )}
// // // //                 </td>
// // // //               </tr>
// // // //             </tbody>
// // // //           </table>
// // // //         </div>

// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // // Styles
// // // // const containerStyle = {
// // // //   maxWidth: '900px',
// // // //   margin: '0 auto',
// // // //   padding: '20px',
// // // //   borderRadius: '12px',
// // // //   fontFamily: 'Segoe UI, sans-serif',
// // // // };

// // // // const tableStyle = {
// // // //   width: '100%',
// // // //   borderCollapse: 'collapse',
// // // //   marginTop: "20px",
// // // // };

// // // // const tableHeaderStyle = {
// // // //   border: '1px solid #ddd',
// // // //   textAlign: 'center',
// // // //   fontWeight: 'bold',
// // // //   backgroundColor: '#b15cd6',
// // // //   color: 'white',
// // // //   padding: '8px',
// // // // };

// // // // const tableCellStyle = {
// // // //   border: '1px solid #ddd',
// // // //   textAlign: 'center',
// // // //   padding: '8px',
// // // // };

// // // // // Simple table styles for send order section
// // // // const simpleTableStyle = {
// // // //   width: '100%',
// // // //   borderCollapse: 'collapse',
// // // // };

// // // // const simpleCellStyle = {
// // // //   padding: window.innerWidth < 500 ? "5px" : '15px',
// // // //   textAlign: 'left',
// // // //   borderBottom: '1px solid #eee',
// // // // };

// // // // const inputStyle = {
// // // //   width: '100px',
// // // //   padding: '5px',
// // // //   fontSize: '14px',
// // // //   border: 'none',
// // // //   outline: 'none',
// // // //   backgroundColor: '#f7f7f7',
// // // // };

// // // // const iconButtonStyle = {
// // // //   background: 'none',
// // // //   border: 'none',
// // // //   cursor: 'pointer',
// // // //   fontSize: '18px',
// // // //   color: '#4A148C',
// // // // };

// // // // export default Billing;









// // import React, { useEffect, useState } from 'react';
// // import { FaEdit, FaSave } from 'react-icons/fa';
// // import axios from 'axios';
// // import "./Settings.css";

// // const Billing = () => {
// //   const vendorId = localStorage.getItem("vendorId") || "42";

// //   const [selectedOptions, setSelectedOptions] = useState({});
// //   const [editMode, setEditMode] = useState({});
// //   const [billingData, setBillingData] = useState(null);
// //   const [showTooltip, setShowTooltip] = useState(false);
// //   const [isEditMode, setIsEditMode] = useState(false);

// //   // ✅ Simple state for send order functionality
// //   const [sendToOption, setSendToOption] = useState('none');
// //   // ✅ Function to map backend status to dropdown option
// //   // ✅ Function to map backend status to dropdown option
// //   const mapStatusToOption = (status) => {
// //     switch (status) {
// //       case 'CONFIRMED':
// //         return 'chef';
// //       case 'DELIVERED':
// //         return 'delivery';
// //       case 'HOLD':
// //       default:
// //         return 'delivery';
// //     }
// //   };

// //   // ✅ Function to map dropdown option to backend status
// //   const mapOptionToStatus = (option) => {
// //     switch (option) {
// //       case 'chef':
// //         return 'CONFIRMED';
// //       case 'delivery':
// //       default:
// //         return 'DELIVERED';
// //     }
// //   };
// //   // ✅ Initialize from API data
// //   const initializeSelectedOptions = (apiData) => {
// //     setSelectedOptions({
// //       serviceCharges: {
// //         discount: apiData.serviceCharges ?? 0,
// //         type: apiData.serviceChargesType === "CUSTOMER_PAYABLE" ? "user" : "no user",
// //         apply: apiData.serviceChargesApply || null,
// //         unit: "Percentage",
// //       },
// //       platformCharges: {
// //         type: apiData.platformChargeType === "CUSTOMER_PAYABLE" ? "user" : "no user",
// //         unit: "Percentage",
// //       }
// //     });

// //     // ✅ Set the dropdown based on backend status
// //     if (apiData.initialOrderStatus) {
// //       const option = mapStatusToOption(apiData.initialOrderStatus);
// //       setSendToOption(option);
// //     }
// //   };

// //   // ✅ Fetch data from backend
// //   const fetchBillingData = async () => {
// //     const token = localStorage.getItem("authToken");
// //     if (!token) {
// //       console.warn("⚠️ No token found in localStorage.");
// //       return null;
// //     }

// //     try {
// //       const res = await axios.get(
// //         `https://backend.maamaas.com/food/api/billing/get/${vendorId}`,
// //         { headers: { Authorization: `Bearer ${token}` } }
// //       );
// //       setBillingData(res.data);
// //       initializeSelectedOptions(res.data);
// //       return res.data;
// //     } catch (err) {
// //       console.error("❌ Failed to fetch billing data:", err?.response?.data || err);
// //       return null;
// //     }
// //   };

// //   // ✅ Handle send order action
// //   const handleSendOrder = async () => {
// //     const token = localStorage.getItem("authToken");
// //     if (!token) {
// //       alert("No authentication token found");
// //       return;
// //     }


// //     let newStatus;
// //     switch (sendToOption) {
// //       case 'chef':
// //         newStatus = 'CONFIRMED';
// //         break;
// //       case 'delivery':
// //         newStatus = 'DELIVERED';
// //         break;
// //       case 'none':
// //       default:
// //         newStatus = 'PENDING';
// //         break;
// //     }

// //     try {
// //       // First get the current billing data
// //       const currentBillingData = billingData || await fetchBillingData();

// //       if (!currentBillingData) {
// //         alert("❌ No billing data found");
// //         return;
// //       }

// //       const updateData = {
// //         ...currentBillingData,
// //         initialOrderStatus: newStatus
// //       };

// //       // Use the PUT endpoint to update
// //       await axios.put(
// //         `https://backend.maamaas.com/food/api/billing/edit/${currentBillingData.id}`,
// //         updateData,
// //         {
// //           headers: {
// //             "Content-Type": "application/json",
// //             Authorization: `Bearer ${token}`,
// //           },
// //         }
// //       );

// //       alert(`✅ Order status updated to: ${newStatus}`);

// //       // Refresh billing data to show updated status
// //       fetchBillingData();

// //     } catch (error) {
// //       console.error("❌ Failed to update order status:", error);
// //       alert("❌ Error updating order status");
// //     }
// //   };

// //   useEffect(() => {
// //     fetchBillingData();
// //   }, []);

// //   // ✅ Toggle Edit Mode
// //   const toggleEdit = async (key) => {
// //     const isEdit = editMode[key];
// //     const token = localStorage.getItem("authToken");
// //     const id = billingData?.id || null;

// //     if (isEdit && id) {
// //       const updatedData = {
// //         ...billingData,
// //         id,
// //         vendorId,

// //         serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
// //         serviceChargesType:
// //           selectedOptions.serviceCharges?.type === "user"
// //             ? "CUSTOMER_PAYABLE"
// //             : "BUSINESS_BORNE",
// //         serviceChargesApply: selectedOptions.serviceCharges?.apply,

// //         platformChargeType:
// //           selectedOptions.platformCharges?.type === "user"
// //             ? "CUSTOMER_PAYABLE"
// //             : "BUSINESS_BORNE",
// //       };

// //       try {
// //         await axios.put(
// //           `https://backend.maamaas.com/food/api/billing/edit/${id}`,
// //           updatedData,
// //           {
// //             headers: {
// //               "Content-Type": "application/json",
// //               ...(token && { Authorization: `Bearer ${token}` }),
// //             },
// //           }
// //         );
// //         alert("✅ Charges updated successfully!");
// //         await fetchBillingData();
// //       } catch (err) {
// //         console.error("❌ Failed to update charges:", err);
// //         alert("❌ Error saving changes.");
// //       }
// //     }

// //     setEditMode((prev) => ({
// //       ...prev,
// //       [key]: !prev[key]
// //     }));
// //   };

// //   // ✅ Toggle apply (Applicable / Not_Applicable)
// //   const handleApplyChange = (label) => {
// //     setSelectedOptions(prev => ({
// //       ...prev,
// //       [label]: {
// //         ...prev[label],
// //         apply: prev[label]?.apply === "Applicable" ? "Not_Applicable" : "Applicable",
// //       },
// //     }));
// //   };

// //   // ✅ Handle charge type checkbox (user / no user)
// //   const handleOptionChange = (label, selectedType) => {
// //     setSelectedOptions(prev => ({
// //       ...prev,
// //       [label]: {
// //         ...prev[label],
// //         type: selectedType
// //       }
// //     }));
// //   };

// //   // ✅ Handle numeric input for service charges only
// //   const handleDiscountChange = (label, value) => {
// //     setSelectedOptions(prev => ({
// //       ...prev,
// //       [label]: {
// //         ...prev[label],
// //         discount: value
// //       }
// //     }));
// //   };

// //   // ✅ Save all changes
// //   const handleSaveCharges = async () => {
// //     const token = localStorage.getItem("authToken");

// //     const requestBody = {
// //       ...billingData,
// //       id: billingData?.id || 0,
// //       vendorId: billingData?.vendorId || vendorId,

// //       // Service charges (with numeric and apply)
// //       serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
// //       serviceChargesType:
// //         selectedOptions.serviceCharges?.type === "user"
// //           ? "CUSTOMER_PAYABLE"
// //           : "BUSINESS_BORNE",
// //       serviceChargesApply: selectedOptions.serviceCharges?.apply,

// //       // Platform charges (type only)
// //       platformChargeType:
// //         selectedOptions.platformCharges?.type === "user"
// //           ? "CUSTOMER_PAYABLE"
// //           : "BUSINESS_BORNE",
// //     };

// //     try {
// //       await axios.post(
// //         `https://backend.maamaas.com/food/api/billing/add/charges/${vendorId}`,
// //         requestBody,
// //         {
// //           headers: {
// //             "Content-Type": "application/json",
// //             ...(token && { Authorization: `Bearer ${token}` }),
// //           },
// //         }
// //       );
// //       alert("✅ Charges saved successfully!");
// //     } catch (err) {
// //       console.error("❌ Backend error:", err?.response?.data || err);
// //       alert(`❌ Failed to save charges: ${err?.response?.data?.error || "Internal Server Error"}`);
// //     }
// //   };
// //   // Handle edit button click
// //   const handleEditClick = () => {
// //     setIsEditMode(true);
// //   };

// //   // Handle save/confirm button click
// //   const handleSaveClick = async () => {
// //     const token = localStorage.getItem("authToken");
// //     if (!token) {
// //       alert("No authentication token found");
// //       return;
// //     }

// //     let newStatus;
// //     switch (sendToOption) {
// //       case 'chef':
// //         newStatus = 'CONFIRMED';
// //         break;
// //       case 'delivery':
// //       default:
// //         newStatus = 'DELIVERED';
// //         break;
// //     }

// //     try {
// //       const currentBillingData = billingData || await fetchBillingData();
// //       if (!currentBillingData) {
// //         alert("❌ No billing data found");
// //         return;
// //       }

// //       const updateData = {
// //         ...currentBillingData,
// //         initialOrderStatus: newStatus
// //       };

// //       await axios.put(
// //         `https://backend.maamaas.com/food/api/billing/edit/${currentBillingData.id}`,
// //         updateData,
// //         {
// //           headers: {
// //             "Content-Type": "application/json",
// //             Authorization: `Bearer ${token}`,
// //           },
// //         }
// //       );

// //       alert(`✅ Order status updated to: ${newStatus}`);
// //       setIsEditMode(false);
// //       fetchBillingData();

// //     } catch (error) {
// //       console.error("❌ Failed to update order status:", error);
// //       alert("❌ Error updating order status");
// //     }
// //   };

// //   // Handle cancel edit
// //   const handleCancelEdit = () => {
// //     if (billingData?.initialOrderStatus) {
// //       const option = mapStatusToOption(billingData.initialOrderStatus);
// //       setSendToOption(option);
// //     }
// //     setIsEditMode(false);
// //   };
// //   return (
// //     <div className='billingsetup' style={containerStyle}>


// //       {/* Billing Table Section */}
// //       <div style={{ marginBottom: '20px' }}>
// //         <h3 style={{ marginBottom: '0px', color: 'rgb(177, 92, 214)' }}>Billing Configuration</h3>
// //         <div style={{
// //           width: "100%",
// //           overflowX: "auto",
// //           overflowY: "auto",
// //           maxHeight: "500px",
// //         }}>
// //           <table style={tableStyle}>
// //             <thead>
// //               <tr>
// //                 <th style={tableHeaderStyle}>Charge Type</th>
// //                 <th style={tableHeaderStyle}>Customer Payable</th>
// //                 <th style={tableHeaderStyle}>Business Borne</th>
// //                 <th style={tableHeaderStyle}>Visibility</th>
// //                 <th style={tableHeaderStyle}>Unit</th>
// //                 <th style={tableHeaderStyle}>Value</th>
// //                 <th style={tableHeaderStyle}>Actions</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {/* ✅ Service Charges Row */}
// //               <tr>
// //                 <td style={tableCellStyle}><strong>Service Charges</strong></td>
// //                 <td style={tableCellStyle}>
// //                   <input
// //                     type="checkbox"
// //                     checked={selectedOptions['serviceCharges']?.type === 'user'}
// //                     onChange={() => handleOptionChange('serviceCharges', 'user')}
// //                     disabled={!editMode['serviceCharges']}
// //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// //                   />
// //                 </td>
// //                 <td style={tableCellStyle}>
// //                   <input
// //                     type="checkbox"
// //                     checked={selectedOptions['serviceCharges']?.type === 'no user'}
// //                     onChange={() => handleOptionChange('serviceCharges', 'no user')}
// //                     disabled={!editMode['serviceCharges']}
// //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// //                   />
// //                 </td>
// //                 <td style={tableCellStyle}>
// //                   <input
// //                     type="checkbox"
// //                     checked={selectedOptions['serviceCharges']?.apply === 'Applicable'}
// //                     onChange={() => handleApplyChange('serviceCharges')}
// //                     disabled={!editMode['serviceCharges']}
// //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// //                   />
// //                 </td>
// //                 <td style={tableCellStyle}>Percentage</td>
// //                 <td style={tableCellStyle}>
// //                   {editMode['serviceCharges'] ? (
// //                     <input
// //                       type="number"
// //                       placeholder="Enter value"
// //                       value={selectedOptions['serviceCharges']?.discount || ''}
// //                       onChange={(e) => handleDiscountChange('serviceCharges', e.target.value)}
// //                       style={inputStyle}
// //                     />
// //                   ) : (
// //                     selectedOptions['serviceCharges']?.discount || '--'
// //                   )}
// //                 </td>
// //                 <td style={tableCellStyle}>
// //                   <button
// //                     onClick={() => toggleEdit('serviceCharges')}
// //                     style={iconButtonStyle}
// //                   >
// //                     {editMode['serviceCharges'] ? <FaSave /> : <FaEdit />}
// //                   </button>
// //                 </td>
// //               </tr>

// //               {/* ✅ Platform Charges Row (Type only) */}
// //               <tr>
// //                 <td style={tableCellStyle}><strong>Platform Charges</strong></td>
// //                 <td style={tableCellStyle}>
// //                   <input
// //                     type="checkbox"
// //                     checked={selectedOptions['platformCharges']?.type === 'user'}
// //                     onChange={() => handleOptionChange('platformCharges', 'user')}
// //                     disabled={!editMode['platformCharges']}
// //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// //                   />
// //                 </td>
// //                 <td style={tableCellStyle}>
// //                   <input
// //                     type="checkbox"
// //                     checked={selectedOptions['platformCharges']?.type === 'no user'}
// //                     onChange={() => handleOptionChange('platformCharges', 'no user')}
// //                     disabled={!editMode['platformCharges']}
// //                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
// //                   />
// //                 </td>
// //                 <td style={tableCellStyle}>--</td>
// //                 <td style={tableCellStyle}>--</td>
// //                 <td style={tableCellStyle}>--</td>
// //                 <td style={tableCellStyle}>
// //                   <button
// //                     onClick={() => toggleEdit('platformCharges')}
// //                     style={iconButtonStyle}
// //                   >
// //                     {editMode['platformCharges'] ? <FaSave /> : <FaEdit />}
// //                   </button>
// //                 </td>
// //               </tr>
// //             </tbody>
// //           </table>
// //         </div>
// //       </div>

// //       <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
// //         <button
// //           onClick={handleSaveCharges}
// //           style={{
// //             background: "rgb(177 93 198)",
// //             color: "#fff",
// //             borderRadius: "6px",
// //             padding: "8px 20px",
// //             border: "none",
// //             cursor: "pointer"
// //           }}
// //         >
// //           Save
// //         </button>
// //       </div>

// //       {/* Simple One-Line Send Order Table */}
// //       <div style={{ marginBottom: '30px' }}>
// //         <div style={{ position: 'relative', display: 'inline-block' }}>
// //           <div style={{ position: 'relative', display: 'inline-block' }}>
// //             <h3 style={{ marginBottom: '15px', color: 'rgb(177, 92, 214)', display: 'flex', alignItems: 'center', gap: '8px' }}>
// //               Order Destination
// //               <span
// //                 style={{
// //                   cursor: 'pointer',
// //                   fontSize: '16px',
// //                   color: 'rgb(177, 92, 214)',
// //                   display: 'inline-flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center',
// //                   background: 'rgba(177, 92, 214, 0.1)',
// //                   borderRadius: '50%',
// //                   marginTop:"8px",
// //                   width: '20px',
// //                   height: '20px',
// //                   fontWeight: 'bold',
// //                   border: '1px solid rgba(177, 92, 214, 0.3)',
// //                 }}
// //                 onMouseEnter={() => setShowTooltip(true)}
// //                 onMouseLeave={() => setShowTooltip(false)}
// //               >
// //                 i
// //               </span>
// //             </h3>

// //             {showTooltip && (
// //               <div style={{
// //                 position: 'absolute',
// //                 top: '40px',
// //                 left: '0',
// //                 backgroundColor: '#333',
// //                 color: 'white',
// //                 padding: '10px',
// //                 borderRadius: '4px',
// //                 fontSize: '12px',
// //                 width: '250px',
// //                 zIndex: 1000,
// //                 boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
// //               }}>
// //                 <strong>Choose where orders go after placement:</strong><br /><br />
// //                 • <strong>Delivery:</strong> Orders are marked as completed for delivery.<br />
// //                 • <strong>Chef:</strong> Orders go to kitchen for preparation first.
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //         <div style={{
// //           width: "100%",
// //           overflowX: "auto",
// //           border: '1px solid #ddd',
// //           borderRadius: '8px',
// //           backgroundColor: '#f8f9fa'
// //         }}>
// //           <table style={simpleTableStyle}>
// //             <tbody>
// //               <tr>
// //                 <td style={{ ...simpleCellStyle, whiteSpace: "nowrap" }}>
// //                   <strong>Send Order To :</strong>
// //                   {/* {billingData?.initialOrderStatus && (
// //                     <div style={{
// //                       fontSize: '12px',
// //                       color: '#666',
// //                       marginTop: '4px',
// //                       fontWeight: 'normal'
// //                     }}>
// //                       Current: {billingData.initialOrderStatus}
// //                     </div>
// //                   )} */}
// //                 </td>
// //                 <td style={simpleCellStyle}>
// //                   <select
// //                     value={sendToOption}
// //                     onChange={(e) => setSendToOption(e.target.value)}
// //                     disabled={!isEditMode}
// //                     style={{
// //                       padding: '8px 12px',
// //                       borderRadius: '6px',
// //                       border: '1px solid #ccc',
// //                       backgroundColor: 'white',
// //                       minWidth: window.innerWidth < 500 ? "auto" : '200px',
// //                       fontSize: '14px',
// //                       textAlign: 'center',
// //                     }}
// //                   >

// //                     <option value="chef">Chef</option>
// //                     <option value="delivery">Delivery</option>
// //                   </select>
// //                 </td>
// //                 <td style={{ ...simpleCellStyle, textAlign: 'right', }}>
// //                   {!isEditMode ? (
// //                     <button
// //                       onClick={handleEditClick}
// //                       style={{
// //                         background: "#b15cd6",
// //                         color: "white",
// //                         border: "none",
// //                         borderRadius: "6px",
// //                         padding: window.innerWidth < 500 ? "8px 15px" : "8px 24px",
// //                         cursor: "pointer",
// //                         fontSize: '14px'
// //                       }}
// //                     >
// //                       Edit
// //                     </button>
// //                   ) : (
// //                     <>
// //                       {/* <button
// //                         onClick={handleCancelEdit}
// //                         style={{
// //                           background: "#6c757d",
// //                           color: "white",
// //                           border: "none",
// //                           borderRadius: "6px",
// //                           padding: window.innerWidth < 500 ? "8px 15px" : "8px 24px",
// //                           cursor: "pointer",
// //                           fontSize: '14px'
// //                         }}
// //                       >
// //                         Cancel
// //                       </button> */}
// //                       <button
// //                         onClick={handleSaveClick}
// //                         style={{
// //                           background: "rgb(177, 92, 214)",
// //                           color: "white",
// //                           border: "none",
// //                           borderRadius: "6px",
// //                           padding: window.innerWidth < 500 ? "8px 15px" : "8px 24px",
// //                           cursor: "pointer",
// //                           fontSize: '14px'
// //                         }}
// //                       >
// //                         Save
// //                       </button>
// //                     </>
// //                   )}
// //                 </td>
// //               </tr>
// //             </tbody>
// //           </table>
// //         </div>

// //       </div>
// //     </div>
// //   );
// // };

// // // Styles
// // const containerStyle = {
// //   maxWidth: '900px',
// //   margin: '0 auto',
// //   padding: '20px',
// //   borderRadius: '12px',
// //   fontFamily: 'Segoe UI, sans-serif',
// // };

// // const tableStyle = {
// //   width: '100%',
// //   borderCollapse: 'collapse',
// //   marginTop: "20px",
// // };

// // const tableHeaderStyle = {
// //   border: '1px solid #ddd',
// //   textAlign: 'center',
// //   fontWeight: 'bold',
// //   backgroundColor: '#b15cd6',
// //   color: 'white',
// //   padding: '8px',
// // };

// // const tableCellStyle = {
// //   border: '1px solid #ddd',
// //   textAlign: 'center',
// //   padding: '8px',
// // };

// // // Simple table styles for send order section
// // const simpleTableStyle = {
// //   width: '100%',
// //   borderCollapse: 'collapse',
// // };

// // const simpleCellStyle = {
// //   padding: window.innerWidth < 500 ? "5px" : '15px',
// //   textAlign: 'left',
// //   borderBottom: '1px solid #eee',
// // };

// // const inputStyle = {
// //   width: '100px',
// //   padding: '5px',
// //   fontSize: '14px',
// //   border: 'none',
// //   outline: 'none',
// //   backgroundColor: '#f7f7f7',
// // };

// // const iconButtonStyle = {
// //   background: 'none',
// //   border: 'none',
// //   cursor: 'pointer',
// //   fontSize: '18px',
// //   color: '#4A148C',
// // };

// // export default Billing;









// import React, { useEffect, useState } from 'react';
// import { FaEdit, FaSave } from 'react-icons/fa';
// import axios from 'axios';
// import "./Settings.css";

// const Billing = () => {
//   const vendorId = localStorage.getItem("vendorId") || "42";

//   const [selectedOptions, setSelectedOptions] = useState({});
//   const [editMode, setEditMode] = useState({});
//   const [billingData, setBillingData] = useState(null);
//   const [showTooltip, setShowTooltip] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   // Add these with your other useState declarations
//   const [showBillingTooltip, setShowBillingTooltip] = useState(false);

//   // ✅ Simple state for send order functionality
//   const [sendToOption, setSendToOption] = useState('none');
//   // ✅ Function to map backend status to dropdown option
//   // ✅ Function to map backend status to dropdown option
//   const mapStatusToOption = (status) => {
//     switch (status) {
//       case 'CONFIRMED':
//         return 'chef';
//       case 'DELIVERED':
//         return 'delivery';
//       case 'HOLD':
//       default:
//         return 'delivery';
//     }
//   };

//   // ✅ Function to map dropdown option to backend status
//   const mapOptionToStatus = (option) => {
//     switch (option) {
//       case 'chef':
//         return 'CONFIRMED';
//       case 'delivery':
//       default:
//         return 'DELIVERED';
//     }
//   };
//   // ✅ Initialize from API data
//   const initializeSelectedOptions = (apiData) => {
//     setSelectedOptions({
//       serviceCharges: {
//         discount: apiData.serviceCharges ?? 0,
//         type: apiData.serviceChargesType === "CUSTOMER_PAYABLE" ? "user" : "no user",
//         apply: apiData.serviceChargesApply || null,
//         unit: "Percentage",
//       },
//       platformCharges: {
//         type: apiData.platformChargeType === "CUSTOMER_PAYABLE" ? "user" : "no user",
//         unit: "Percentage",
//       }
//     });

//     // ✅ Set the dropdown based on backend status
//     if (apiData.initialOrderStatus) {
//       const option = mapStatusToOption(apiData.initialOrderStatus);
//       setSendToOption(option);
//     }
//   };

//   // ✅ Fetch data from backend
//   const fetchBillingData = async () => {
//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       console.warn("⚠️ No token found in localStorage.");
//       return null;
//     }

//     try {
//       const res = await axios.get(
//         `https://backend.maamaas.com/food/api/billing/get/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setBillingData(res.data);
//       initializeSelectedOptions(res.data);
//       return res.data;
//     } catch (err) {
//       console.error("❌ Failed to fetch billing data:", err?.response?.data || err);
//       return null;
//     }
//   };

//   // ✅ Handle send order action
//   const handleSendOrder = async () => {
//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       alert("No authentication token found");
//       return;
//     }


//     let newStatus;
//     switch (sendToOption) {
//       case 'chef':
//         newStatus = 'CONFIRMED';
//         break;
//       case 'delivery':
//         newStatus = 'DELIVERED';
//         break;
//       case 'none':
//       default:
//         newStatus = 'PENDING';
//         break;
//     }

//     try {
//       // First get the current billing data
//       const currentBillingData = billingData || await fetchBillingData();

//       if (!currentBillingData) {
//         alert("❌ No billing data found");
//         return;
//       }

//       const updateData = {
//         ...currentBillingData,
//         initialOrderStatus: newStatus
//       };

//       // Use the PUT endpoint to update
//       await axios.put(
//         `https://backend.maamaas.com/food/api/billing/edit/${currentBillingData.id}`,
//         updateData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       alert(`✅ Order status updated to: ${newStatus}`);

//       // Refresh billing data to show updated status
//       fetchBillingData();

//     } catch (error) {
//       console.error("❌ Failed to update order status:", error);
//       alert("❌ Error updating order status");
//     }
//   };

//   useEffect(() => {
//     fetchBillingData();
//   }, []);

//   // ✅ Toggle Edit Mode
//   const toggleEdit = async (key) => {
//     const isEdit = editMode[key];
//     const token = localStorage.getItem("authToken");
//     const id = billingData?.id || null;

//     if (isEdit && id) {
//       const updatedData = {
//         ...billingData,
//         id,
//         vendorId,

//         serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
//         serviceChargesType:
//           selectedOptions.serviceCharges?.type === "user"
//             ? "CUSTOMER_PAYABLE"
//             : "BUSINESS_BORNE",
//         serviceChargesApply: selectedOptions.serviceCharges?.apply,

//         platformChargeType:
//           selectedOptions.platformCharges?.type === "user"
//             ? "CUSTOMER_PAYABLE"
//             : "BUSINESS_BORNE",
//       };

//       try {
//         await axios.put(
//           `https://backend.maamaas.com/food/api/billing/edit/${id}`,
//           updatedData,
//           {
//             headers: {
//               "Content-Type": "application/json",
//               ...(token && { Authorization: `Bearer ${token}` }),
//             },
//           }
//         );
//         alert("✅ Charges updated successfully!");
//         await fetchBillingData();
//       } catch (err) {
//         console.error("❌ Failed to update charges:", err);
//         alert("❌ Error saving changes.");
//       }
//     }

//     setEditMode((prev) => ({
//       ...prev,
//       [key]: !prev[key]
//     }));
//   };

//   // ✅ Toggle apply (Applicable / Not_Applicable)
//   const handleApplyChange = (label) => {
//     setSelectedOptions(prev => ({
//       ...prev,
//       [label]: {
//         ...prev[label],
//         apply: prev[label]?.apply === "Applicable" ? "Not_Applicable" : "Applicable",
//       },
//     }));
//   };

//   // ✅ Handle charge type checkbox (user / no user)
//   const handleOptionChange = (label, selectedType) => {
//     setSelectedOptions(prev => ({
//       ...prev,
//       [label]: {
//         ...prev[label],
//         type: selectedType
//       }
//     }));
//   };

//   // ✅ Handle numeric input for service charges only
//   const handleDiscountChange = (label, value) => {
//     setSelectedOptions(prev => ({
//       ...prev,
//       [label]: {
//         ...prev[label],
//         discount: value
//       }
//     }));
//   };

//   // ✅ Save all changes
//   const handleSaveCharges = async () => {
//     const token = localStorage.getItem("authToken");

//     const requestBody = {
//       ...billingData,
//       id: billingData?.id || 0,
//       vendorId: billingData?.vendorId || vendorId,

//       // Service charges (with numeric and apply)
//       serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
//       serviceChargesType:
//         selectedOptions.serviceCharges?.type === "user"
//           ? "CUSTOMER_PAYABLE"
//           : "BUSINESS_BORNE",
//       serviceChargesApply: selectedOptions.serviceCharges?.apply,

//       // Platform charges (type only)
//       platformChargeType:
//         selectedOptions.platformCharges?.type === "user"
//           ? "CUSTOMER_PAYABLE"
//           : "BUSINESS_BORNE",
//     };

//     try {
//       await axios.post(
//         `https://backend.maamaas.com/food/api/billing/add/charges/${vendorId}`,
//         requestBody,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             ...(token && { Authorization: `Bearer ${token}` }),
//           },
//         }
//       );
//       alert("✅ Charges saved successfully!");
//     } catch (err) {
//       console.error("❌ Backend error:", err?.response?.data || err);
//       alert(`❌ Failed to save charges: ${err?.response?.data?.error || "Internal Server Error"}`);
//     }
//   };

//   // Handle edit button click
//   const handleEditClick = () => {
//     setIsEditMode(true);
//   };

//   // Handle save/confirm button click
//   const handleSaveClick = async () => {
//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       alert("No authentication token found");
//       return;
//     }

//     let newStatus;
//     switch (sendToOption) {
//       case 'chef':
//         newStatus = 'CONFIRMED';
//         break;
//       case 'delivery':
//       default:
//         newStatus = 'DELIVERED';
//         break;
//     }

//     try {
//       const currentBillingData = billingData || await fetchBillingData();
//       if (!currentBillingData) {
//         alert("❌ No billing data found");
//         return;
//       }

//       const updateData = {
//         ...currentBillingData,
//         initialOrderStatus: newStatus
//       };

//       await axios.put(
//         `https://backend.maamaas.com/food/api/billing/edit/${currentBillingData.id}`,
//         updateData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       alert(`✅ Order status updated to: ${newStatus}`);
//       setIsEditMode(false);
//       fetchBillingData();

//     } catch (error) {
//       console.error("❌ Failed to update order status:", error);
//       alert("❌ Error updating order status");
//     }
//   };

//   // Handle cancel edit
//   const handleCancelEdit = () => {
//     if (billingData?.initialOrderStatus) {
//       const option = mapStatusToOption(billingData.initialOrderStatus);
//       setSendToOption(option);
//     }
//     setIsEditMode(false);
//   };
//   return (
//     <div className='billingsetup' style={containerStyle}>

//       {/* Billing Table Section */}
//       <div style={{ marginBottom: '20px' }}>
//         <div style={{ position: 'relative', display: 'inline-block' }}>
//           <h3 style={{ marginBottom: '0px', color: 'rgb(177, 92, 214)', display: 'flex', alignItems: 'center', gap: '8px' }}>
//             Billing Configuration
//             <span
//               style={{
//                 cursor: 'pointer',
//                 fontSize: '16px',
//                 color: 'rgb(177, 92, 214)',
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 background: 'rgba(177, 92, 214, 0.1)',
//                 borderRadius: '50%',
//                 marginTop: "8px",
//                 width: '20px',
//                 height: '20px',
//                 fontWeight: 'bold',
//                 border: '1px solid rgba(177, 92, 214, 0.3)',
//               }}
//               onMouseEnter={() => setShowBillingTooltip(true)}
//               onMouseLeave={() => setShowBillingTooltip(false)}
//             >
//               i
//             </span>
//           </h3>

//           {showBillingTooltip && (
//             <div style={{
//               position: 'absolute',
//               top: '40px',
//               left: '0',
//               backgroundColor: '#333',
//               color: 'white',
//               padding: '10px',
//               borderRadius: '4px',
//               fontSize: '12px',
//               width: '250px',
//               zIndex: 1000,
//               boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
//             }}>
//               <strong>Billing Configuration Guide:</strong><br /><br />
//               • <strong>Customer Payable:</strong> Charges will be paid by the Customer.<br />
//               • <strong>Business Borne:</strong> Charges will be paid by the Business Owner.<br />
//               • <strong>Visibility:</strong> Vendor can choose to apply or hide service charges from customer.<br />
//               • <strong>Service Charges:</strong> Additional fee paid by Customer to Business.<br />
//               • <strong>Platform Charges:</strong> Fee for using the Platform.
//             </div>
//           )}
//         </div>

//         <div style={{
//           width: "100%",
//           overflowX: "auto",
//           overflowY: "auto",
//           maxHeight: "500px",
//         }}>
//           <table style={tableStyle}>
//             <thead>
//               <tr>
//                 <th style={tableHeaderStyle}>Charge Type</th>
//                 <th style={tableHeaderStyle}>Customer Payable</th>
//                 <th style={tableHeaderStyle}>Business Borne</th>
//                 <th style={tableHeaderStyle}>Visibility</th>
//                 <th style={tableHeaderStyle}>Unit</th>
//                 <th style={tableHeaderStyle}>Value</th>
//                 <th style={tableHeaderStyle}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {/* ✅ Service Charges Row */}
//               <tr>
//                 <td style={tableCellStyle}><strong>Service Charges</strong></td>
//                 <td style={tableCellStyle}>
//                   <input
//                     type="checkbox"
//                     checked={selectedOptions['serviceCharges']?.type === 'user'}
//                     onChange={() => handleOptionChange('serviceCharges', 'user')}
//                     disabled={!editMode['serviceCharges']}
//                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
//                   />
//                 </td>
//                 <td style={tableCellStyle}>
//                   <input
//                     type="checkbox"
//                     checked={selectedOptions['serviceCharges']?.type === 'no user'}
//                     onChange={() => handleOptionChange('serviceCharges', 'no user')}
//                     disabled={!editMode['serviceCharges']}
//                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
//                   />
//                 </td>
//                 <td style={tableCellStyle}>
//                   <input
//                     type="checkbox"
//                     checked={selectedOptions['serviceCharges']?.apply === 'Applicable'}
//                     onChange={() => handleApplyChange('serviceCharges')}
//                     disabled={!editMode['serviceCharges']}
//                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
//                   />
//                 </td>
//                 <td style={tableCellStyle}>Percentage</td>
//                 <td style={tableCellStyle}>
//                   {editMode['serviceCharges'] ? (
//                     <input
//                       type="number"
//                       placeholder="Enter value"
//                       value={selectedOptions['serviceCharges']?.discount || ''}
//                       onChange={(e) => handleDiscountChange('serviceCharges', e.target.value)}
//                       style={inputStyle}
//                     />
//                   ) : (
//                     selectedOptions['serviceCharges']?.discount || '--'
//                   )}
//                 </td>
//                 <td style={tableCellStyle}>
//                   <button
//                     onClick={() => toggleEdit('serviceCharges')}
//                     style={iconButtonStyle}
//                   >
//                     {editMode['serviceCharges'] ? <FaSave /> : <FaEdit />}
//                   </button>
//                 </td>
//               </tr>

//               {/* ✅ Platform Charges Row (Type only) */}
//               <tr>
//                 <td style={tableCellStyle}><strong>Platform Charges</strong></td>
//                 <td style={tableCellStyle}>
//                   <input
//                     type="checkbox"
//                     checked={selectedOptions['platformCharges']?.type === 'user'}
//                     onChange={() => handleOptionChange('platformCharges', 'user')}
//                     disabled={!editMode['platformCharges']}
//                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
//                   />
//                 </td>
//                 <td style={tableCellStyle}>
//                   <input
//                     type="checkbox"
//                     checked={selectedOptions['platformCharges']?.type === 'no user'}
//                     onChange={() => handleOptionChange('platformCharges', 'no user')}
//                     disabled={!editMode['platformCharges']}
//                     style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
//                   />
//                 </td>
//                 <td style={tableCellStyle}>--</td>
//                 <td style={tableCellStyle}>--</td>
//                 <td style={tableCellStyle}>--</td>
//                 <td style={tableCellStyle}>
//                   <button
//                     onClick={() => toggleEdit('platformCharges')}
//                     style={iconButtonStyle}
//                   >
//                     {editMode['platformCharges'] ? <FaSave /> : <FaEdit />}
//                   </button>
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
//         <button
//           onClick={handleSaveCharges}
//           style={{
//             background: "rgb(177 93 198)",
//             color: "#fff",
//             borderRadius: "6px",
//             padding: "8px 20px",
//             border: "none",
//             cursor: "pointer"
//           }}
//         >
//           Save
//         </button>
//       </div>

//       {/* Simple One-Line Send Order Table */}
//       <div style={{ marginBottom: '30px' }}>
//         <div style={{ position: 'relative', display: 'inline-block' }}>
//           <div style={{ position: 'relative', display: 'inline-block' }}>
//             <h3 style={{ marginBottom: '15px', color: 'rgb(177, 92, 214)', display: 'flex', alignItems: 'center', gap: '8px' }}>
//               Order Destination
//               <span
//                 style={{
//                   cursor: 'pointer',
//                   fontSize: '16px',
//                   color: 'rgb(177, 92, 214)',
//                   display: 'inline-flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   background: 'rgba(177, 92, 214, 0.1)',
//                   borderRadius: '50%',
//                   marginTop: "8px",
//                   width: '20px',
//                   height: '20px',
//                   fontWeight: 'bold',
//                   border: '1px solid rgba(177, 92, 214, 0.3)',
//                 }}
//                 onMouseEnter={() => setShowTooltip(true)}
//                 onMouseLeave={() => setShowTooltip(false)}
//               >
//                 i
//               </span>
//             </h3>

//             {showTooltip && (
//               <div style={{
//                 position: 'absolute',
//                 top: '40px',
//                 left: '0',
//                 backgroundColor: '#333',
//                 color: 'white',
//                 padding: '10px',
//                 borderRadius: '4px',
//                 fontSize: '12px',
//                 width: '250px',
//                 zIndex: 1000,
//                 boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
//               }}>
//                 <strong>Choose where orders go after placement:</strong><br /><br />
//                 • <strong>Delivery:</strong> Orders are marked as completed for delivery.<br />
//                 • <strong>Chef:</strong> Orders go to kitchen for preparation first.
//               </div>
//             )}
//           </div>
//         </div>
//         <div style={{
//           width: "100%",
//           overflowX: "auto",
//           border: '1px solid #ddd',
//           borderRadius: '8px',
//           backgroundColor: '#f8f9fa'
//         }}>
//           <table style={simpleTableStyle}>
//             <tbody>
//               <tr>
//                 <td style={{ ...simpleCellStyle, whiteSpace: "nowrap" }}>
//                   <strong>Send Order To :</strong>
//                   {/* {billingData?.initialOrderStatus && (
//                     <div style={{
//                       fontSize: '12px',
//                       color: '#666',
//                       marginTop: '4px',
//                       fontWeight: 'normal'
//                     }}>
//                       Current: {billingData.initialOrderStatus}
//                     </div>
//                   )} */}
//                 </td>
//                 <td style={simpleCellStyle}>
//                   <select
//                     value={sendToOption}
//                     onChange={(e) => setSendToOption(e.target.value)}
//                     disabled={!isEditMode}
//                     style={{
//                       padding: '8px 12px',
//                       borderRadius: '6px',
//                       border: '1px solid #ccc',
//                       backgroundColor: 'white',
//                       minWidth: window.innerWidth < 500 ? "auto" : '200px',
//                       fontSize: '14px',
//                       textAlign: 'center',
//                     }}
//                   >

//                     <option value="chef">Chef</option>
//                     <option value="delivery">Delivery</option>
//                   </select>
//                 </td>
//                 <td style={{ ...simpleCellStyle, textAlign: 'right', }}>
//                   {!isEditMode ? (
//                     <button
//                       onClick={handleEditClick}
//                       style={{
//                         background: "#b15cd6",
//                         color: "white",
//                         border: "none",
//                         borderRadius: "6px",
//                         padding: window.innerWidth < 500 ? "8px 15px" : "8px 24px",
//                         cursor: "pointer",
//                         fontSize: '14px'
//                       }}
//                     >
//                       Edit
//                     </button>
//                   ) : (
//                     <>
//                       {/* <button
//                         onClick={handleCancelEdit}
//                         style={{
//                           background: "#6c757d",
//                           color: "white",
//                           border: "none",
//                           borderRadius: "6px",
//                           padding: window.innerWidth < 500 ? "8px 15px" : "8px 24px",
//                           cursor: "pointer",
//                           fontSize: '14px'
//                         }}
//                       >
//                         Cancel
//                       </button> */}
//                       <button
//                         onClick={handleSaveClick}
//                         style={{
//                           background: "rgb(177, 92, 214)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: "6px",
//                           padding: window.innerWidth < 500 ? "8px 15px" : "8px 24px",
//                           cursor: "pointer",
//                           fontSize: '14px'
//                         }}
//                       >
//                         Save
//                       </button>
//                     </>
//                   )}
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>

//       </div>
//     </div>
//   );
// };

// // Styles
// const containerStyle = {
//   maxWidth: '900px',
//   margin: '0 auto',
//   padding: '20px',
//   borderRadius: '12px',
//   fontFamily: 'Segoe UI, sans-serif',
// };

// const tableStyle = {
//   width: '100%',
//   borderCollapse: 'collapse',
//   marginTop: "20px",
// };

// const tableHeaderStyle = {
//   border: '1px solid #ddd',
//   textAlign: 'center',
//   fontWeight: 'bold',
//   backgroundColor: '#b15cd6',
//   color: 'white',
//   padding: '8px',
// };

// const tableCellStyle = {
//   border: '1px solid #ddd',
//   textAlign: 'center',
//   padding: '8px',
// };

// // Simple table styles for send order section
// const simpleTableStyle = {
//   width: '100%',
//   borderCollapse: 'collapse',
// };

// const simpleCellStyle = {
//   padding: window.innerWidth < 500 ? "5px" : '15px',
//   textAlign: 'left',
//   borderBottom: '1px solid #eee',
// };

// const inputStyle = {
//   width: '100px',
//   padding: '5px',
//   fontSize: '14px',
//   border: 'none',
//   outline: 'none',
//   backgroundColor: '#f7f7f7',
// };

// const iconButtonStyle = {
//   background: 'none',
//   border: 'none',
//   cursor: 'pointer',
//   fontSize: '18px',
//   color: '#4A148C',
// };

// export default Billing;







import React, { useEffect, useState } from 'react';
import { FaEdit, FaSave } from 'react-icons/fa';
import axios from 'axios';
import "./Settings.css";

const Billing = () => {
  const vendorId = localStorage.getItem("vendorId") || "42";

  const [selectedOptions, setSelectedOptions] = useState({});
  const [editMode, setEditMode] = useState({});
  const [billingData, setBillingData] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showBillingTooltip, setShowBillingTooltip] = useState(false);
  const [loading, setLoading] = useState(false);

  // ✅ Simple state for send order functionality
  const [sendToOption, setSendToOption] = useState('delivery');

  // ✅ Function to map backend status to dropdown option
  const mapStatusToOption = (status) => {
    switch (status) {
      case 'CONFIRMED':
        return 'chef';
      case 'DELIVERED':
        return 'delivery';
      case 'HOLD':
      default:
        return 'delivery';
    }
  };

  // ✅ Function to map dropdown option to backend status
  const mapOptionToStatus = (option) => {
    switch (option) {
      case 'chef':
        return 'CONFIRMED';
      case 'delivery':
      default:
        return 'DELIVERED';
    }
  };

  // ✅ Initialize from API data
  const initializeSelectedOptions = (apiData) => {
    setSelectedOptions({
      serviceCharges: {
        discount: apiData.serviceCharges ?? 0,
        type: apiData.serviceChargesType === "CUSTOMER_PAYABLE" ? "user" : "no user",
        apply: apiData.serviceChargesApply || "Not_Applicable",
        unit: "Percentage",
      },
      platformCharges: {
        type: apiData.platformChargeType === "CUSTOMER_PAYABLE" ? "user" : "no user",
        unit: "Percentage",
      }
    });

    // ✅ Set the dropdown based on backend status
    if (apiData.initialOrderStatus) {
      const option = mapStatusToOption(apiData.initialOrderStatus);
      setSendToOption(option);
    }
  };

  // ✅ Fetch data from backend
  const fetchBillingData = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      console.warn("⚠️ No token found in localStorage.");
      return null;
    }

    setLoading(true);
    try {
      const res = await axios.get(
        `https://backend.maamaas.com/food/api/billing/get/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setBillingData(res.data);
      initializeSelectedOptions(res.data);
      return res.data;
    } catch (err) {
      console.error("❌ Failed to fetch billing data:", err?.response?.data || err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBillingData();
  }, []);

  // ✅ Toggle Edit Mode for individual rows
  const toggleEdit = async (key) => {
    const isEdit = editMode[key];
    const token = localStorage.getItem("authToken");
    const id = billingData?.id || null;

    if (isEdit && id) {
      const updatedData = {
        ...billingData,
        id,
        vendorId: parseInt(vendorId),
        serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
        serviceChargesType:
          selectedOptions.serviceCharges?.type === "user"
            ? "CUSTOMER_PAYABLE"
            : "BUSINESS_BORNE",
        serviceChargesApply: selectedOptions.serviceCharges?.apply || "Not_Applicable",
        platformChargeType:
          selectedOptions.platformCharges?.type === "user"
            ? "CUSTOMER_PAYABLE"
            : "BUSINESS_BORNE",
        initialOrderStatus: sendToOption === "chef" ? "CONFIRMED" : "DELIVERED"
      };

      try {
        await axios.put(
          `https://backend.maamaas.com/food/api/billing/edit/${id}`,
          updatedData,
          {
            headers: {
              "Content-Type": "application/json",
              ...(token && { Authorization: `Bearer ${token}` }),
            },
          }
        );
        alert("✅ Charges updated successfully!");
        await fetchBillingData();
      } catch (err) {
        console.error("❌ Failed to update charges:", err);
        alert("❌ Error saving changes.");
      }
    }

    setEditMode((prev) => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // ✅ Toggle apply (Applicable / Not_Applicable)
  const handleApplyChange = (label) => {
    setSelectedOptions(prev => ({
      ...prev,
      [label]: {
        ...prev[label],
        apply: prev[label]?.apply === "Applicable" ? "Not_Applicable" : "Applicable",
      },
    }));
  };

  // ✅ Handle charge type checkbox (user / no user)
  const handleOptionChange = (label, selectedType) => {
    setSelectedOptions(prev => ({
      ...prev,
      [label]: {
        ...prev[label],
        type: selectedType
      }
    }));
  };

  // ✅ Handle numeric input for service charges only
  const handleDiscountChange = (label, value) => {
    setSelectedOptions(prev => ({
      ...prev,
      [label]: {
        ...prev[label],
        discount: value
      }
    }));
  };

  // ✅ Save all changes - MAIN FIXED FUNCTION
  const handleSaveCharges = async () => {
    const token = localStorage.getItem("authToken");

    // Check if we already have billing data
    if (billingData && billingData.id) {
      // Use PUT to update existing
      await updateWithPut(billingData.id);
    } else {
      // Use POST to create new
      await createWithPost();
    }
  };

  // Helper: Create new billing with POST
  const createWithPost = async () => {
    const token = localStorage.getItem("authToken");

    // POST request body - NO id field
    const postData = {
      vendorId: parseInt(vendorId),
      serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
      serviceChargesType:
        selectedOptions.serviceCharges?.type === "user"
          ? "CUSTOMER_PAYABLE"
          : "BUSINESS_BORNE",
      serviceChargesApply: selectedOptions.serviceCharges?.apply || "Not_Applicable",
      platformChargeType:
        selectedOptions.platformCharges?.type === "user"
          ? "CUSTOMER_PAYABLE"
          : "BUSINESS_BORNE",
      initialOrderStatus: "DELIVERED" // Default status
    };


    try {
      const response = await axios.post(
        `https://backend.maamaas.com/food/api/billing/add/charges/${vendorId}`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        }
      );

      alert("✅ Billing configuration created successfully!");
      await fetchBillingData();

    } catch (error) {
      console.error("❌ POST Error:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });

      // If POST fails, try PUT as fallback
      alert("⚠️ POST failed. Trying PUT as fallback...");
      await updateWithPut(vendorId); // Use vendorId as ID for PUT
    }
  };

  // Helper: Update existing billing with PUT
  const updateWithPut = async (billingId) => {
    const token = localStorage.getItem("authToken");

    const putData = {
      ...billingData,
      id: parseInt(billingId),
      vendorId: parseInt(vendorId),
      serviceCharges: Number(selectedOptions.serviceCharges?.discount) || 0,
      serviceChargesType:
        selectedOptions.serviceCharges?.type === "user"
          ? "CUSTOMER_PAYABLE"
          : "BUSINESS_BORNE",
      serviceChargesApply: selectedOptions.serviceCharges?.apply || "Not_Applicable",
      platformChargeType:
        selectedOptions.platformCharges?.type === "user"
          ? "CUSTOMER_PAYABLE"
          : "BUSINESS_BORNE",
      initialOrderStatus: sendToOption === "chef" ? "CONFIRMED" : "DELIVERED"
    };


    try {
      await axios.put(
        `https://backend.maamaas.com/food/api/billing/edit/${billingId}`,
        putData,
        {
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        }
      );
      alert("✅ Billing configuration updated successfully!");
      await fetchBillingData();

    } catch (error) {
      console.error("❌ PUT Error:", error.response?.data || error);
      alert(`❌ Failed to save: ${error.response?.data?.message || error.message}`);
    }
  };

  // Handle edit button click for order destination
  const handleEditClick = () => {
    setIsEditMode(true);
  };

  // Handle save/confirm button click for order destination
  const handleSaveClick = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("No authentication token found");
      return;
    }

    let newStatus;
    switch (sendToOption) {
      case 'chef':
        newStatus = 'CONFIRMED';
        break;
      case 'delivery':
      default:
        newStatus = 'DELIVERED';
        break;
    }

    try {
      const currentBillingData = billingData || await fetchBillingData();
      if (!currentBillingData) {
        alert("❌ No billing data found");
        return;
      }

      const updateData = {
        ...currentBillingData,
        initialOrderStatus: newStatus
      };

      await axios.put(
        `https://backend.maamaas.com/food/api/billing/edit/${currentBillingData.id}`,
        updateData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert(`✅ Order status updated to: ${newStatus}`);
      setIsEditMode(false);
      fetchBillingData();

    } catch (error) {
      console.error("❌ Failed to update order status:", error);
      alert("❌ Error updating order status");
    }
  };

  // Handle cancel edit for order destination
  const handleCancelEdit = () => {
    if (billingData?.initialOrderStatus) {
      const option = mapStatusToOption(billingData.initialOrderStatus);
      setSendToOption(option);
    }
    setIsEditMode(false);
  };

  // Debug function to test POST endpoint
  const testPostEndpoint = async () => {
    const token = localStorage.getItem("authToken");

    const testData = {
      vendorId: parseInt(vendorId),
      serviceCharges: 5,
      serviceChargesType: "CUSTOMER_PAYABLE",
      serviceChargesApply: "Applicable",
      platformChargeType: "BUSINESS_BORNE",
      initialOrderStatus: "DELIVERED"
    };


    try {
      const response = await axios.post(
        `https://backend.maamaas.com/food/api/billing/add/charges/${vendorId}`,
        testData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert("✅ POST endpoint works!");
      await fetchBillingData();
    } catch (error) {
      console.error("❌ POST test failed:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
      alert(`❌ POST test failed: ${error.response?.data?.message || error.message}`);
    }
  };

  return (
    <div className='billingsetup' style={{...containerStyle, width:window.innerWidth<768 ? "90vw" : " "}}>

      {/* Billing Table Section */}
      <div style={{ marginBottom: '20px' }}>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <h3 style={{ marginBottom: '0px', color: 'rgb(177, 92, 214)', display: 'flex', alignItems: 'center', gap: '8px' }}>
            Billing Configuration
            <span
              style={{
                cursor: 'pointer',
                fontSize: '16px',
                color: 'rgb(177, 92, 214)',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(177, 92, 214, 0.1)',
                borderRadius: '50%',
                marginTop: "8px",
                width: '20px',
                height: '20px',
                fontWeight: 'bold',
                border: '1px solid rgba(177, 92, 214, 0.3)',
              }}
              onMouseEnter={() => setShowBillingTooltip(true)}
              onMouseLeave={() => setShowBillingTooltip(false)}
            >
              i
            </span>
          </h3>

          {showBillingTooltip && (
            <div style={{
              position: 'absolute',
              top: '40px',
              left: '0',
              backgroundColor: '#333',
              color: 'white',
              padding: '10px',
              borderRadius: '4px',
              fontSize: '12px',
              width: '250px',
              zIndex: 1000,
              boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
            }}>
              <strong>Billing Configuration Guide:</strong><br /><br />
              • <strong>Customer Payable:</strong> Charges will be paid by the Customer.<br />
              • <strong>Business Borne:</strong> Charges will be paid by the Business Owner.<br />
              • <strong>Visibility:</strong> Vendor can choose to apply or hide service charges from customer.<br />
              • <strong>Service Charges:</strong> Additional fee paid by Customer to Business.<br />
              • <strong>Platform Charges:</strong> Fee for using the Platform.
            </div>
          )}
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
            Loading billing data...
          </div>
        ) : (
          <>
            <div style={{
              width: "100%",
              overflowX: "auto",
              overflowY: "auto",
              maxHeight: "500px",
            }}>
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={tableHeaderStyle}>Charge Type</th>
                    <th style={tableHeaderStyle}>Customer Payable</th>
                    <th style={tableHeaderStyle}>Business Borne</th>
                    <th style={tableHeaderStyle}>Visibility</th>
                    <th style={tableHeaderStyle}>Unit</th>
                    <th style={tableHeaderStyle}>Value</th>
                    <th style={tableHeaderStyle}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {/* ✅ Service Charges Row */}
                  <tr>
                    <td style={tableCellStyle}><strong>Service Charges</strong></td>
                    <td style={tableCellStyle}>
                      <input
                        type="checkbox"
                        checked={selectedOptions['serviceCharges']?.type === 'user'}
                        onChange={() => handleOptionChange('serviceCharges', 'user')}
                        disabled={!editMode['serviceCharges']}
                        style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
                      />
                    </td>
                    <td style={tableCellStyle}>
                      <input
                        type="checkbox"
                        checked={selectedOptions['serviceCharges']?.type === 'no user'}
                        onChange={() => handleOptionChange('serviceCharges', 'no user')}
                        disabled={!editMode['serviceCharges']}
                        style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
                      />
                    </td>
                    <td style={tableCellStyle}>
                      <input
                        type="checkbox"
                        checked={selectedOptions['serviceCharges']?.apply === 'Applicable'}
                        onChange={() => handleApplyChange('serviceCharges')}
                        disabled={!editMode['serviceCharges']}
                        style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
                      />
                    </td>
                    <td style={tableCellStyle}>Percentage</td>
                    <td style={tableCellStyle}>
                      {editMode['serviceCharges'] ? (
                        <input
                          type="number"
                          placeholder="Enter value"
                          value={selectedOptions['serviceCharges']?.discount || ''}
                          onChange={(e) => handleDiscountChange('serviceCharges', e.target.value)}
                          style={inputStyle}
                        />
                      ) : (
                        selectedOptions['serviceCharges']?.discount || '--'
                      )}
                    </td>
                    <td style={tableCellStyle}>
                      <button
                        onClick={() => toggleEdit('serviceCharges')}
                        style={iconButtonStyle}
                      >
                        {editMode['serviceCharges'] ? <FaSave /> : <FaEdit />}
                      </button>
                    </td>
                  </tr>

                  {/* ✅ Platform Charges Row (Type only) */}
                  <tr>
                    <td style={tableCellStyle}><strong>Platform Charges</strong></td>
                    <td style={tableCellStyle}>
                      <input
                        type="checkbox"
                        checked={selectedOptions['platformCharges']?.type === 'user'}
                        onChange={() => handleOptionChange('platformCharges', 'user')}
                        disabled={!editMode['platformCharges']}
                        style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
                      />
                    </td>
                    <td style={tableCellStyle}>
                      <input
                        type="checkbox"
                        checked={selectedOptions['platformCharges']?.type === 'no user'}
                        onChange={() => handleOptionChange('platformCharges', 'no user')}
                        disabled={!editMode['platformCharges']}
                        style={{ transform: 'scale(1.2)', accentColor: '#4A148C' }}
                      />
                    </td>
                    <td style={tableCellStyle}>--</td>
                    <td style={tableCellStyle}>--</td>
                    <td style={tableCellStyle}>--</td>
                    <td style={tableCellStyle}>
                      <button
                        onClick={() => toggleEdit('platformCharges')}
                        style={iconButtonStyle}
                      >
                        {editMode['platformCharges'] ? <FaSave /> : <FaEdit />}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Save button at right end */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button
                onClick={handleSaveCharges}
                style={{
                  background: "rgb(177 93 198)",
                  color: "#fff",
                  borderRadius: "6px",
                  padding: "8px 20px",
                  border: "none",
                  cursor: "pointer"
                }}
                disabled={loading}
              >
                {loading ? 'Saving...' : 'Save'}
              </button>
            </div>
          </>
        )}
      </div>

      {/* Simple One-Line Send Order Table */}
      <div style={{ marginBottom: '30px' }}>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <h3 style={{ marginBottom: '15px', color: 'rgb(177, 92, 214)', display: 'flex', alignItems: 'center', gap: '8px' }}>
              Order Destination
              <span
                style={{
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: 'rgb(177, 92, 214)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'rgba(177, 92, 214, 0.1)',
                  borderRadius: '50%',
                  marginTop: "8px",
                  width: '20px',
                  height: '20px',
                  fontWeight: 'bold',
                  border: '1px solid rgba(177, 92, 214, 0.3)',
                }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                i
              </span>
            </h3>

            {showTooltip && (
              <div style={{
                position: 'absolute',
                top: '40px',
                left: '0',
                backgroundColor: '#333',
                color: 'white',
                padding: '10px',
                borderRadius: '4px',
                fontSize: '12px',
                width: '250px',
                zIndex: 1000,
                boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
              }}>
                <strong>Choose where orders go after placement:</strong><br /><br />
                • <strong>Delivery:</strong> Orders are marked as completed for delivery.<br />
                • <strong>Chef:</strong> Orders go to kitchen for preparation first.
              </div>
            )}
          </div>
        </div>
        <div style={{
          width: "100%",
          overflowX: "auto",
          border: '1px solid #ddd',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa'
        }}>
          <table style={simpleTableStyle}>
            <tbody>
              <tr>
                <td style={{ ...simpleCellStyle, whiteSpace: "nowrap" }}>
                  <strong>Send Order To :</strong>
                </td>
                <td style={simpleCellStyle}>
                  <select
                    value={sendToOption}
                    onChange={(e) => setSendToOption(e.target.value)}
                    disabled={!isEditMode}
                    style={{
                      padding: '8px 12px',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                      backgroundColor: 'white',
                      minWidth: window.innerWidth < 500 ? "auto" : '200px',
                      fontSize: '14px',
                      textAlign: 'center',
                    }}
                  >
                    <option value="chef">Chef</option>
                    <option value="delivery">Delivery</option>
                  </select>
                </td>
                <td style={{ ...simpleCellStyle, textAlign: 'right', }}>
                  {!isEditMode ? (
                    <button
                      onClick={handleEditClick}
                      style={{
                        background: "#b15cd6",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        padding: window.innerWidth < 500 ? "8px 15px" : "8px 24px",
                        cursor: "pointer",
                        fontSize: '14px'
                      }}
                    >
                      Edit
                    </button>
                  ) : (
                    <button
                      onClick={handleSaveClick}
                      style={{
                        background: "rgb(177, 92, 214)",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        padding: window.innerWidth < 500 ? "8px 15px" : "8px 24px",
                        cursor: "pointer",
                        fontSize: '14px'
                      }}
                    >
                      Save
                    </button>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

// Styles
const containerStyle = {
  maxWidth: '900px',
  margin: '0 auto',
  padding: '20px',
  borderRadius: '12px',
  fontFamily: 'Segoe UI, sans-serif',
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  marginTop: "20px",
};

const tableHeaderStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
  fontWeight: 'bold',
  backgroundColor: '#b15cd6',
  color: 'white',
  padding: '8px',
};

const tableCellStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
  padding: '8px',
};

// Simple table styles for send order section
const simpleTableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
};

const simpleCellStyle = {
  padding: window.innerWidth < 500 ? "5px" : '15px',
  textAlign: 'left',
  borderBottom: '1px solid #eee',
};

const inputStyle = {
  width: '100px',
  padding: '5px',
  fontSize: '14px',
  border: 'none',
  outline: 'none',
  backgroundColor: '#f7f7f7',
};

const iconButtonStyle = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '18px',
  color: '#4A148C',
};

export default Billing;